/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicPrivacyPolicyRouteImport } from './routes/_public/privacy-policy'
import { Route as PublicPricingRouteImport } from './routes/_public/pricing'
import { Route as PublicAboutRouteImport } from './routes/_public/about'
import { Route as PublicSignUpIndexRouteImport } from './routes/_public/sign-up/index'
import { Route as PublicSignInIndexRouteImport } from './routes/_public/sign-in/index'
import { Route as PublicSignUpSplatRouteImport } from './routes/_public/sign-up/$'
import { Route as PublicSignInSplatRouteImport } from './routes/_public/sign-in/$'
import { Route as AuthStaffInviteTokenRouteImport } from './routes/_auth/staff-invite/$token'
import { Route as AuthAppSelectOrganizationRouteImport } from './routes/_auth/app/select-organization'
import { Route as AuthAppAppRouteImport } from './routes/_auth/app/_app'
import { Route as AuthAppAppIndexRouteImport } from './routes/_auth/app/_app/index'
import { Route as AuthAppAppHelpRouteImport } from './routes/_auth/app/_app/help'
import { Route as AuthAppAppUserSettingsIndexRouteImport } from './routes/_auth/app/_app/user-settings/index'
import { Route as AuthAppAppHelpIndexRouteImport } from './routes/_auth/app/_app/help/index'
import { Route as AuthAppAppOrgRenewSubscriptionRouteImport } from './routes/_auth/app/_app/org/renew-subscription'
import { Route as AuthAppAppOrgOrgIdRouteImport } from './routes/_auth/app/_app/org/$orgId'
import { Route as AuthAppAppHelpUserGuideRouteImport } from './routes/_auth/app/_app/help/user-guide'
import { Route as AuthAppAppHelpSupportRouteImport } from './routes/_auth/app/_app/help/support'
import { Route as AuthAppAppOrgOrgIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/index'
import { Route as AuthAppAppHelpUserGuideIndexRouteImport } from './routes/_auth/app/_app/help/user-guide/index'
import { Route as AuthAppAppHelpSupportIndexRouteImport } from './routes/_auth/app/_app/help/support/index'
import { Route as AuthAppAppOrgOrgIdUnder_developmentRouteImport } from './routes/_auth/app/_app/org/$orgId/under_development'
import { Route as AuthAppAppOrgOrgIdCustomersRouteImport } from './routes/_auth/app/_app/org/$orgId/customers'
import { Route as AuthAppAppOrgOrgIdAttendanceRouteImport } from './routes/_auth/app/_app/org/$orgId/attendance'
import { Route as AuthAppAppHelpUserGuideStaffManagementRouteImport } from './routes/_auth/app/_app/help/user-guide/staff-management'
import { Route as AuthAppAppHelpUserGuideScheduleManagementRouteImport } from './routes/_auth/app/_app/help/user-guide/schedule-management'
import { Route as AuthAppAppHelpUserGuideEnrollmentProcessRouteImport } from './routes/_auth/app/_app/help/user-guide/enrollment-process'
import { Route as AuthAppAppHelpUserGuideCustomerPlansRouteImport } from './routes/_auth/app/_app/help/user-guide/customer-plans'
import { Route as AuthAppAppHelpUserGuideCustomerManagementRouteImport } from './routes/_auth/app/_app/help/user-guide/customer-management'
import { Route as AuthAppAppHelpUserGuideAttendanceTrackingRouteImport } from './routes/_auth/app/_app/help/user-guide/attendance-tracking'
import { Route as AuthAppAppOrgOrgIdStaffIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/staff/index'
import { Route as AuthAppAppOrgOrgIdSettingsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/index'
import { Route as AuthAppAppOrgOrgIdSchedulesIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/schedules/index'
import { Route as AuthAppAppOrgOrgIdOrgManagementIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/org-management/index'
import { Route as AuthAppAppOrgOrgIdEstablishmentsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/establishments/index'
import { Route as AuthAppAppOrgOrgIdEnrollmentsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/enrollments/index'
import { Route as AuthAppAppOrgOrgIdCustomersIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/customers/index'
import { Route as AuthAppAppOrgOrgIdCustomerPlansIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/customer-plans/index'
import { Route as AuthAppAppOrgOrgIdBillingIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/billing/index'
import { Route as AuthAppAppOrgOrgIdAttendanceIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/attendance/index'
import { Route as AuthAppAppHelpSupportTicketsIndexRouteImport } from './routes/_auth/app/_app/help/support/tickets/index'
import { Route as AuthAppAppOrgOrgIdStaffStaffIdRouteImport } from './routes/_auth/app/_app/org/$orgId/staff/$staffId'
import { Route as AuthAppAppOrgOrgIdSchedulesNewRouteImport } from './routes/_auth/app/_app/org/$orgId/schedules/new'
import { Route as AuthAppAppOrgOrgIdSchedulesScheduleIdRouteImport } from './routes/_auth/app/_app/org/$orgId/schedules/$scheduleId'
import { Route as AuthAppAppOrgOrgIdEnrollmentsNewRouteImport } from './routes/_auth/app/_app/org/$orgId/enrollments/new'
import { Route as AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRouteImport } from './routes/_auth/app/_app/org/$orgId/enrollments/$enrollmentId'
import { Route as AuthAppAppOrgOrgIdCustomersNewRouteImport } from './routes/_auth/app/_app/org/$orgId/customers/new'
import { Route as AuthAppAppOrgOrgIdCustomersCustomerIdRouteImport } from './routes/_auth/app/_app/org/$orgId/customers/$customerId'
import { Route as AuthAppAppOrgOrgIdBillingInvoiceIdRouteImport } from './routes/_auth/app/_app/org/$orgId/billing/$invoiceId'
import { Route as AuthAppAppHelpSupportTicketsTicketIdRouteImport } from './routes/_auth/app/_app/help/support/tickets/$ticketId'
import { Route as AuthAppAppOrgOrgIdStaffStaffIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/staff/$staffId/index'
import { Route as AuthAppAppOrgOrgIdSettingsPaymentMethodsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/payment-methods/index'
import { Route as AuthAppAppOrgOrgIdSettingsImportIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/import/index'
import { Route as AuthAppAppOrgOrgIdSettingsFeaturesIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/features/index'
import { Route as AuthAppAppOrgOrgIdSettingsBillingIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/billing/index'
import { Route as AuthAppAppOrgOrgIdSettingsAuditEventsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/audit-events/index'
import { Route as AuthAppAppOrgOrgIdSchedulesScheduleIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/schedules/$scheduleId/index'
import { Route as AuthAppAppOrgOrgIdOrgManagementFinancialAnalysisIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/org-management/financial-analysis/index'
import { Route as AuthAppAppOrgOrgIdOrgManagementCustomerRiskAnalysisIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/org-management/customer-risk-analysis/index'
import { Route as AuthAppAppOrgOrgIdOrgManagementCostManagementIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/org-management/cost-management/index'
import { Route as AuthAppAppOrgOrgIdEventsEnrollmentExpiryReminderIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/events/enrollment-expiry-reminder/index'
import { Route as AuthAppAppOrgOrgIdEventsBirthdayReminderIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/events/birthday-reminder/index'
import { Route as AuthAppAppOrgOrgIdCustomersCustomerIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/customers/$customerId/index'
import { Route as AuthAppAppOrgOrgIdBillingNewIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/billing/new/index'
import { Route as AuthAppAppOrgOrgIdStaffStaffIdSchedulesRouteImport } from './routes/_auth/app/_app/org/$orgId/staff/$staffId/schedules'
import { Route as AuthAppAppOrgOrgIdStaffStaffIdPermissionsRouteImport } from './routes/_auth/app/_app/org/$orgId/staff/$staffId/permissions'
import { Route as AuthAppAppOrgOrgIdStaffStaffIdMigrateSchedulesRouteImport } from './routes/_auth/app/_app/org/$orgId/staff/$staffId/migrate-schedules'
import { Route as AuthAppAppOrgOrgIdStaffStaffIdEditRouteImport } from './routes/_auth/app/_app/org/$orgId/staff/$staffId/edit'
import { Route as AuthAppAppOrgOrgIdSettingsImportCustomersRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/import/customers'
import { Route as AuthAppAppOrgOrgIdSchedulesScheduleIdSessionsRouteImport } from './routes/_auth/app/_app/org/$orgId/schedules/$scheduleId/sessions'
import { Route as AuthAppAppOrgOrgIdSchedulesScheduleIdEnrollmentsRouteImport } from './routes/_auth/app/_app/org/$orgId/schedules/$scheduleId/enrollments'
import { Route as AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdEditRouteImport } from './routes/_auth/app/_app/org/$orgId/enrollments/$enrollmentId/edit'
import { Route as AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdBillingRouteImport } from './routes/_auth/app/_app/org/$orgId/enrollments/$enrollmentId/billing'
import { Route as AuthAppAppOrgOrgIdCustomersCustomerIdSessionsRouteImport } from './routes/_auth/app/_app/org/$orgId/customers/$customerId/sessions'
import { Route as AuthAppAppOrgOrgIdCustomersCustomerIdEnrollmentsRouteImport } from './routes/_auth/app/_app/org/$orgId/customers/$customerId/enrollments'
import { Route as AuthAppAppOrgOrgIdCustomersCustomerIdEditRouteImport } from './routes/_auth/app/_app/org/$orgId/customers/$customerId/edit'
import { Route as AuthAppAppOrgOrgIdCustomersCustomerIdBillingRouteImport } from './routes/_auth/app/_app/org/$orgId/customers/$customerId/billing'
import { Route as AuthAppAppOrgOrgIdBillingInvoiceIdRefundsRouteImport } from './routes/_auth/app/_app/org/$orgId/billing/$invoiceId/refunds'
import { Route as AuthAppAppOrgOrgIdBillingInvoiceIdPaymentsRouteImport } from './routes/_auth/app/_app/org/$orgId/billing/$invoiceId/payments'
import { Route as AuthAppAppOrgOrgIdBillingInvoiceIdOverviewRouteImport } from './routes/_auth/app/_app/org/$orgId/billing/$invoiceId/overview'
import { Route as AuthAppAppOrgOrgIdBillingInvoiceIdDisputesRouteImport } from './routes/_auth/app/_app/org/$orgId/billing/$invoiceId/disputes'
import { Route as AuthAppAppOrgOrgIdAttendanceSessionSessionIdRouteImport } from './routes/_auth/app/_app/org/$orgId/attendance/session/$sessionId'
import { Route as AuthAppAppOrgOrgIdOrgManagementCostManagementRecurringIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/org-management/cost-management/recurring/index'
import { Route as AuthAppAppOrgOrgIdOrgManagementCostManagementExpensesIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/org-management/cost-management/expenses/index'
import { Route as AuthAppAppOrgOrgIdOrgManagementCostManagementCategoriesIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/org-management/cost-management/categories/index'
import { Route as AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/customers/$customerId/medicalRecords/index'
import { Route as AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsNewRouteImport } from './routes/_auth/app/_app/org/$orgId/customers/$customerId/medicalRecords/new'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicPrivacyPolicyRoute = PublicPrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => PublicRoute,
} as any)
const PublicPricingRoute = PublicPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAboutRoute = PublicAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignUpIndexRoute = PublicSignUpIndexRouteImport.update({
  id: '/sign-up/',
  path: '/sign-up/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignInIndexRoute = PublicSignInIndexRouteImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignUpSplatRoute = PublicSignUpSplatRouteImport.update({
  id: '/sign-up/$',
  path: '/sign-up/$',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignInSplatRoute = PublicSignInSplatRouteImport.update({
  id: '/sign-in/$',
  path: '/sign-in/$',
  getParentRoute: () => PublicRoute,
} as any)
const AuthStaffInviteTokenRoute = AuthStaffInviteTokenRouteImport.update({
  id: '/staff-invite/$token',
  path: '/staff-invite/$token',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAppSelectOrganizationRoute =
  AuthAppSelectOrganizationRouteImport.update({
    id: '/app/select-organization',
    path: '/app/select-organization',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAppAppRoute = AuthAppAppRouteImport.update({
  id: '/app/_app',
  path: '/app',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAppAppIndexRoute = AuthAppAppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAppAppRoute,
} as any)
const AuthAppAppHelpRoute = AuthAppAppHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AuthAppAppRoute,
} as any)
const AuthAppAppUserSettingsIndexRoute =
  AuthAppAppUserSettingsIndexRouteImport.update({
    id: '/user-settings/',
    path: '/user-settings/',
    getParentRoute: () => AuthAppAppRoute,
  } as any)
const AuthAppAppHelpIndexRoute = AuthAppAppHelpIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAppAppHelpRoute,
} as any)
const AuthAppAppOrgRenewSubscriptionRoute =
  AuthAppAppOrgRenewSubscriptionRouteImport.update({
    id: '/org/renew-subscription',
    path: '/org/renew-subscription',
    getParentRoute: () => AuthAppAppRoute,
  } as any)
const AuthAppAppOrgOrgIdRoute = AuthAppAppOrgOrgIdRouteImport.update({
  id: '/org/$orgId',
  path: '/org/$orgId',
  getParentRoute: () => AuthAppAppRoute,
} as any)
const AuthAppAppHelpUserGuideRoute = AuthAppAppHelpUserGuideRouteImport.update({
  id: '/user-guide',
  path: '/user-guide',
  getParentRoute: () => AuthAppAppHelpRoute,
} as any)
const AuthAppAppHelpSupportRoute = AuthAppAppHelpSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthAppAppHelpRoute,
} as any)
const AuthAppAppOrgOrgIdIndexRoute = AuthAppAppOrgOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAppAppOrgOrgIdRoute,
} as any)
const AuthAppAppHelpUserGuideIndexRoute =
  AuthAppAppHelpUserGuideIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppHelpSupportIndexRoute =
  AuthAppAppHelpSupportIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppHelpSupportRoute,
  } as any)
const AuthAppAppOrgOrgIdUnder_developmentRoute =
  AuthAppAppOrgOrgIdUnder_developmentRouteImport.update({
    id: '/under_development',
    path: '/under_development',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdCustomersRoute =
  AuthAppAppOrgOrgIdCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdAttendanceRoute =
  AuthAppAppOrgOrgIdAttendanceRouteImport.update({
    id: '/attendance',
    path: '/attendance',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppHelpUserGuideStaffManagementRoute =
  AuthAppAppHelpUserGuideStaffManagementRouteImport.update({
    id: '/staff-management',
    path: '/staff-management',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppHelpUserGuideScheduleManagementRoute =
  AuthAppAppHelpUserGuideScheduleManagementRouteImport.update({
    id: '/schedule-management',
    path: '/schedule-management',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppHelpUserGuideEnrollmentProcessRoute =
  AuthAppAppHelpUserGuideEnrollmentProcessRouteImport.update({
    id: '/enrollment-process',
    path: '/enrollment-process',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppHelpUserGuideCustomerPlansRoute =
  AuthAppAppHelpUserGuideCustomerPlansRouteImport.update({
    id: '/customer-plans',
    path: '/customer-plans',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppHelpUserGuideCustomerManagementRoute =
  AuthAppAppHelpUserGuideCustomerManagementRouteImport.update({
    id: '/customer-management',
    path: '/customer-management',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppHelpUserGuideAttendanceTrackingRoute =
  AuthAppAppHelpUserGuideAttendanceTrackingRouteImport.update({
    id: '/attendance-tracking',
    path: '/attendance-tracking',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppOrgOrgIdStaffIndexRoute =
  AuthAppAppOrgOrgIdStaffIndexRouteImport.update({
    id: '/staff/',
    path: '/staff/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdSettingsIndexRoute =
  AuthAppAppOrgOrgIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdSchedulesIndexRoute =
  AuthAppAppOrgOrgIdSchedulesIndexRouteImport.update({
    id: '/schedules/',
    path: '/schedules/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdOrgManagementIndexRoute =
  AuthAppAppOrgOrgIdOrgManagementIndexRouteImport.update({
    id: '/org-management/',
    path: '/org-management/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdEstablishmentsIndexRoute =
  AuthAppAppOrgOrgIdEstablishmentsIndexRouteImport.update({
    id: '/establishments/',
    path: '/establishments/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdEnrollmentsIndexRoute =
  AuthAppAppOrgOrgIdEnrollmentsIndexRouteImport.update({
    id: '/enrollments/',
    path: '/enrollments/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdCustomersIndexRoute =
  AuthAppAppOrgOrgIdCustomersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppOrgOrgIdCustomersRoute,
  } as any)
const AuthAppAppOrgOrgIdCustomerPlansIndexRoute =
  AuthAppAppOrgOrgIdCustomerPlansIndexRouteImport.update({
    id: '/customer-plans/',
    path: '/customer-plans/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdBillingIndexRoute =
  AuthAppAppOrgOrgIdBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdAttendanceIndexRoute =
  AuthAppAppOrgOrgIdAttendanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppOrgOrgIdAttendanceRoute,
  } as any)
const AuthAppAppHelpSupportTicketsIndexRoute =
  AuthAppAppHelpSupportTicketsIndexRouteImport.update({
    id: '/tickets/',
    path: '/tickets/',
    getParentRoute: () => AuthAppAppHelpSupportRoute,
  } as any)
const AuthAppAppOrgOrgIdStaffStaffIdRoute =
  AuthAppAppOrgOrgIdStaffStaffIdRouteImport.update({
    id: '/staff/$staffId',
    path: '/staff/$staffId',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdSchedulesNewRoute =
  AuthAppAppOrgOrgIdSchedulesNewRouteImport.update({
    id: '/schedules/new',
    path: '/schedules/new',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdSchedulesScheduleIdRoute =
  AuthAppAppOrgOrgIdSchedulesScheduleIdRouteImport.update({
    id: '/schedules/$scheduleId',
    path: '/schedules/$scheduleId',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdEnrollmentsNewRoute =
  AuthAppAppOrgOrgIdEnrollmentsNewRouteImport.update({
    id: '/enrollments/new',
    path: '/enrollments/new',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRoute =
  AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRouteImport.update({
    id: '/enrollments/$enrollmentId',
    path: '/enrollments/$enrollmentId',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdCustomersNewRoute =
  AuthAppAppOrgOrgIdCustomersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthAppAppOrgOrgIdCustomersRoute,
  } as any)
const AuthAppAppOrgOrgIdCustomersCustomerIdRoute =
  AuthAppAppOrgOrgIdCustomersCustomerIdRouteImport.update({
    id: '/$customerId',
    path: '/$customerId',
    getParentRoute: () => AuthAppAppOrgOrgIdCustomersRoute,
  } as any)
const AuthAppAppOrgOrgIdBillingInvoiceIdRoute =
  AuthAppAppOrgOrgIdBillingInvoiceIdRouteImport.update({
    id: '/billing/$invoiceId',
    path: '/billing/$invoiceId',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppHelpSupportTicketsTicketIdRoute =
  AuthAppAppHelpSupportTicketsTicketIdRouteImport.update({
    id: '/tickets/$ticketId',
    path: '/tickets/$ticketId',
    getParentRoute: () => AuthAppAppHelpSupportRoute,
  } as any)
const AuthAppAppOrgOrgIdStaffStaffIdIndexRoute =
  AuthAppAppOrgOrgIdStaffStaffIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppOrgOrgIdStaffStaffIdRoute,
  } as any)
const AuthAppAppOrgOrgIdSettingsPaymentMethodsIndexRoute =
  AuthAppAppOrgOrgIdSettingsPaymentMethodsIndexRouteImport.update({
    id: '/settings/payment-methods/',
    path: '/settings/payment-methods/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdSettingsImportIndexRoute =
  AuthAppAppOrgOrgIdSettingsImportIndexRouteImport.update({
    id: '/settings/import/',
    path: '/settings/import/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdSettingsFeaturesIndexRoute =
  AuthAppAppOrgOrgIdSettingsFeaturesIndexRouteImport.update({
    id: '/settings/features/',
    path: '/settings/features/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdSettingsBillingIndexRoute =
  AuthAppAppOrgOrgIdSettingsBillingIndexRouteImport.update({
    id: '/settings/billing/',
    path: '/settings/billing/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdSettingsAuditEventsIndexRoute =
  AuthAppAppOrgOrgIdSettingsAuditEventsIndexRouteImport.update({
    id: '/settings/audit-events/',
    path: '/settings/audit-events/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdSchedulesScheduleIdIndexRoute =
  AuthAppAppOrgOrgIdSchedulesScheduleIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppOrgOrgIdSchedulesScheduleIdRoute,
  } as any)
const AuthAppAppOrgOrgIdOrgManagementFinancialAnalysisIndexRoute =
  AuthAppAppOrgOrgIdOrgManagementFinancialAnalysisIndexRouteImport.update({
    id: '/org-management/financial-analysis/',
    path: '/org-management/financial-analysis/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdOrgManagementCustomerRiskAnalysisIndexRoute =
  AuthAppAppOrgOrgIdOrgManagementCustomerRiskAnalysisIndexRouteImport.update({
    id: '/org-management/customer-risk-analysis/',
    path: '/org-management/customer-risk-analysis/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdOrgManagementCostManagementIndexRoute =
  AuthAppAppOrgOrgIdOrgManagementCostManagementIndexRouteImport.update({
    id: '/org-management/cost-management/',
    path: '/org-management/cost-management/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdEventsEnrollmentExpiryReminderIndexRoute =
  AuthAppAppOrgOrgIdEventsEnrollmentExpiryReminderIndexRouteImport.update({
    id: '/events/enrollment-expiry-reminder/',
    path: '/events/enrollment-expiry-reminder/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdEventsBirthdayReminderIndexRoute =
  AuthAppAppOrgOrgIdEventsBirthdayReminderIndexRouteImport.update({
    id: '/events/birthday-reminder/',
    path: '/events/birthday-reminder/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdCustomersCustomerIdIndexRoute =
  AuthAppAppOrgOrgIdCustomersCustomerIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppOrgOrgIdCustomersCustomerIdRoute,
  } as any)
const AuthAppAppOrgOrgIdBillingNewIndexRoute =
  AuthAppAppOrgOrgIdBillingNewIndexRouteImport.update({
    id: '/billing/new/',
    path: '/billing/new/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdStaffStaffIdSchedulesRoute =
  AuthAppAppOrgOrgIdStaffStaffIdSchedulesRouteImport.update({
    id: '/schedules',
    path: '/schedules',
    getParentRoute: () => AuthAppAppOrgOrgIdStaffStaffIdRoute,
  } as any)
const AuthAppAppOrgOrgIdStaffStaffIdPermissionsRoute =
  AuthAppAppOrgOrgIdStaffStaffIdPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => AuthAppAppOrgOrgIdStaffStaffIdRoute,
  } as any)
const AuthAppAppOrgOrgIdStaffStaffIdMigrateSchedulesRoute =
  AuthAppAppOrgOrgIdStaffStaffIdMigrateSchedulesRouteImport.update({
    id: '/migrate-schedules',
    path: '/migrate-schedules',
    getParentRoute: () => AuthAppAppOrgOrgIdStaffStaffIdRoute,
  } as any)
const AuthAppAppOrgOrgIdStaffStaffIdEditRoute =
  AuthAppAppOrgOrgIdStaffStaffIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthAppAppOrgOrgIdStaffStaffIdRoute,
  } as any)
const AuthAppAppOrgOrgIdSettingsImportCustomersRoute =
  AuthAppAppOrgOrgIdSettingsImportCustomersRouteImport.update({
    id: '/settings/import/customers',
    path: '/settings/import/customers',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdSchedulesScheduleIdSessionsRoute =
  AuthAppAppOrgOrgIdSchedulesScheduleIdSessionsRouteImport.update({
    id: '/sessions',
    path: '/sessions',
    getParentRoute: () => AuthAppAppOrgOrgIdSchedulesScheduleIdRoute,
  } as any)
const AuthAppAppOrgOrgIdSchedulesScheduleIdEnrollmentsRoute =
  AuthAppAppOrgOrgIdSchedulesScheduleIdEnrollmentsRouteImport.update({
    id: '/enrollments',
    path: '/enrollments',
    getParentRoute: () => AuthAppAppOrgOrgIdSchedulesScheduleIdRoute,
  } as any)
const AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdEditRoute =
  AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRoute,
  } as any)
const AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdBillingRoute =
  AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRoute,
  } as any)
const AuthAppAppOrgOrgIdCustomersCustomerIdSessionsRoute =
  AuthAppAppOrgOrgIdCustomersCustomerIdSessionsRouteImport.update({
    id: '/sessions',
    path: '/sessions',
    getParentRoute: () => AuthAppAppOrgOrgIdCustomersCustomerIdRoute,
  } as any)
const AuthAppAppOrgOrgIdCustomersCustomerIdEnrollmentsRoute =
  AuthAppAppOrgOrgIdCustomersCustomerIdEnrollmentsRouteImport.update({
    id: '/enrollments',
    path: '/enrollments',
    getParentRoute: () => AuthAppAppOrgOrgIdCustomersCustomerIdRoute,
  } as any)
const AuthAppAppOrgOrgIdCustomersCustomerIdEditRoute =
  AuthAppAppOrgOrgIdCustomersCustomerIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthAppAppOrgOrgIdCustomersCustomerIdRoute,
  } as any)
const AuthAppAppOrgOrgIdCustomersCustomerIdBillingRoute =
  AuthAppAppOrgOrgIdCustomersCustomerIdBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthAppAppOrgOrgIdCustomersCustomerIdRoute,
  } as any)
const AuthAppAppOrgOrgIdBillingInvoiceIdRefundsRoute =
  AuthAppAppOrgOrgIdBillingInvoiceIdRefundsRouteImport.update({
    id: '/refunds',
    path: '/refunds',
    getParentRoute: () => AuthAppAppOrgOrgIdBillingInvoiceIdRoute,
  } as any)
const AuthAppAppOrgOrgIdBillingInvoiceIdPaymentsRoute =
  AuthAppAppOrgOrgIdBillingInvoiceIdPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AuthAppAppOrgOrgIdBillingInvoiceIdRoute,
  } as any)
const AuthAppAppOrgOrgIdBillingInvoiceIdOverviewRoute =
  AuthAppAppOrgOrgIdBillingInvoiceIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthAppAppOrgOrgIdBillingInvoiceIdRoute,
  } as any)
const AuthAppAppOrgOrgIdBillingInvoiceIdDisputesRoute =
  AuthAppAppOrgOrgIdBillingInvoiceIdDisputesRouteImport.update({
    id: '/disputes',
    path: '/disputes',
    getParentRoute: () => AuthAppAppOrgOrgIdBillingInvoiceIdRoute,
  } as any)
const AuthAppAppOrgOrgIdAttendanceSessionSessionIdRoute =
  AuthAppAppOrgOrgIdAttendanceSessionSessionIdRouteImport.update({
    id: '/session/$sessionId',
    path: '/session/$sessionId',
    getParentRoute: () => AuthAppAppOrgOrgIdAttendanceRoute,
  } as any)
const AuthAppAppOrgOrgIdOrgManagementCostManagementRecurringIndexRoute =
  AuthAppAppOrgOrgIdOrgManagementCostManagementRecurringIndexRouteImport.update(
    {
      id: '/org-management/cost-management/recurring/',
      path: '/org-management/cost-management/recurring/',
      getParentRoute: () => AuthAppAppOrgOrgIdRoute,
    } as any,
  )
const AuthAppAppOrgOrgIdOrgManagementCostManagementExpensesIndexRoute =
  AuthAppAppOrgOrgIdOrgManagementCostManagementExpensesIndexRouteImport.update({
    id: '/org-management/cost-management/expenses/',
    path: '/org-management/cost-management/expenses/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdOrgManagementCostManagementCategoriesIndexRoute =
  AuthAppAppOrgOrgIdOrgManagementCostManagementCategoriesIndexRouteImport.update(
    {
      id: '/org-management/cost-management/categories/',
      path: '/org-management/cost-management/categories/',
      getParentRoute: () => AuthAppAppOrgOrgIdRoute,
    } as any,
  )
const AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsIndexRoute =
  AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsIndexRouteImport.update({
    id: '/medicalRecords/',
    path: '/medicalRecords/',
    getParentRoute: () => AuthAppAppOrgOrgIdCustomersCustomerIdRoute,
  } as any)
const AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsNewRoute =
  AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsNewRouteImport.update({
    id: '/medicalRecords/new',
    path: '/medicalRecords/new',
    getParentRoute: () => AuthAppAppOrgOrgIdCustomersCustomerIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof PublicIndexRoute
  '/about': typeof PublicAboutRoute
  '/pricing': typeof PublicPricingRoute
  '/privacy-policy': typeof PublicPrivacyPolicyRoute
  '/app': typeof AuthAppAppRouteWithChildren
  '/app/select-organization': typeof AuthAppSelectOrganizationRoute
  '/staff-invite/$token': typeof AuthStaffInviteTokenRoute
  '/sign-in/$': typeof PublicSignInSplatRoute
  '/sign-up/$': typeof PublicSignUpSplatRoute
  '/sign-in/': typeof PublicSignInIndexRoute
  '/sign-up/': typeof PublicSignUpIndexRoute
  '/app/help': typeof AuthAppAppHelpRouteWithChildren
  '/app/': typeof AuthAppAppIndexRoute
  '/app/help/support': typeof AuthAppAppHelpSupportRouteWithChildren
  '/app/help/user-guide': typeof AuthAppAppHelpUserGuideRouteWithChildren
  '/app/org/$orgId': typeof AuthAppAppOrgOrgIdRouteWithChildren
  '/app/org/renew-subscription': typeof AuthAppAppOrgRenewSubscriptionRoute
  '/app/help/': typeof AuthAppAppHelpIndexRoute
  '/app/user-settings/': typeof AuthAppAppUserSettingsIndexRoute
  '/app/help/user-guide/attendance-tracking': typeof AuthAppAppHelpUserGuideAttendanceTrackingRoute
  '/app/help/user-guide/customer-management': typeof AuthAppAppHelpUserGuideCustomerManagementRoute
  '/app/help/user-guide/customer-plans': typeof AuthAppAppHelpUserGuideCustomerPlansRoute
  '/app/help/user-guide/enrollment-process': typeof AuthAppAppHelpUserGuideEnrollmentProcessRoute
  '/app/help/user-guide/schedule-management': typeof AuthAppAppHelpUserGuideScheduleManagementRoute
  '/app/help/user-guide/staff-management': typeof AuthAppAppHelpUserGuideStaffManagementRoute
  '/app/org/$orgId/attendance': typeof AuthAppAppOrgOrgIdAttendanceRouteWithChildren
  '/app/org/$orgId/customers': typeof AuthAppAppOrgOrgIdCustomersRouteWithChildren
  '/app/org/$orgId/under_development': typeof AuthAppAppOrgOrgIdUnder_developmentRoute
  '/app/help/support/': typeof AuthAppAppHelpSupportIndexRoute
  '/app/help/user-guide/': typeof AuthAppAppHelpUserGuideIndexRoute
  '/app/org/$orgId/': typeof AuthAppAppOrgOrgIdIndexRoute
  '/app/help/support/tickets/$ticketId': typeof AuthAppAppHelpSupportTicketsTicketIdRoute
  '/app/org/$orgId/billing/$invoiceId': typeof AuthAppAppOrgOrgIdBillingInvoiceIdRouteWithChildren
  '/app/org/$orgId/customers/$customerId': typeof AuthAppAppOrgOrgIdCustomersCustomerIdRouteWithChildren
  '/app/org/$orgId/customers/new': typeof AuthAppAppOrgOrgIdCustomersNewRoute
  '/app/org/$orgId/enrollments/$enrollmentId': typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRouteWithChildren
  '/app/org/$orgId/enrollments/new': typeof AuthAppAppOrgOrgIdEnrollmentsNewRoute
  '/app/org/$orgId/schedules/$scheduleId': typeof AuthAppAppOrgOrgIdSchedulesScheduleIdRouteWithChildren
  '/app/org/$orgId/schedules/new': typeof AuthAppAppOrgOrgIdSchedulesNewRoute
  '/app/org/$orgId/staff/$staffId': typeof AuthAppAppOrgOrgIdStaffStaffIdRouteWithChildren
  '/app/help/support/tickets/': typeof AuthAppAppHelpSupportTicketsIndexRoute
  '/app/org/$orgId/attendance/': typeof AuthAppAppOrgOrgIdAttendanceIndexRoute
  '/app/org/$orgId/billing/': typeof AuthAppAppOrgOrgIdBillingIndexRoute
  '/app/org/$orgId/customer-plans/': typeof AuthAppAppOrgOrgIdCustomerPlansIndexRoute
  '/app/org/$orgId/customers/': typeof AuthAppAppOrgOrgIdCustomersIndexRoute
  '/app/org/$orgId/enrollments/': typeof AuthAppAppOrgOrgIdEnrollmentsIndexRoute
  '/app/org/$orgId/establishments/': typeof AuthAppAppOrgOrgIdEstablishmentsIndexRoute
  '/app/org/$orgId/org-management/': typeof AuthAppAppOrgOrgIdOrgManagementIndexRoute
  '/app/org/$orgId/schedules/': typeof AuthAppAppOrgOrgIdSchedulesIndexRoute
  '/app/org/$orgId/settings/': typeof AuthAppAppOrgOrgIdSettingsIndexRoute
  '/app/org/$orgId/staff/': typeof AuthAppAppOrgOrgIdStaffIndexRoute
  '/app/org/$orgId/attendance/session/$sessionId': typeof AuthAppAppOrgOrgIdAttendanceSessionSessionIdRoute
  '/app/org/$orgId/billing/$invoiceId/disputes': typeof AuthAppAppOrgOrgIdBillingInvoiceIdDisputesRoute
  '/app/org/$orgId/billing/$invoiceId/overview': typeof AuthAppAppOrgOrgIdBillingInvoiceIdOverviewRoute
  '/app/org/$orgId/billing/$invoiceId/payments': typeof AuthAppAppOrgOrgIdBillingInvoiceIdPaymentsRoute
  '/app/org/$orgId/billing/$invoiceId/refunds': typeof AuthAppAppOrgOrgIdBillingInvoiceIdRefundsRoute
  '/app/org/$orgId/customers/$customerId/billing': typeof AuthAppAppOrgOrgIdCustomersCustomerIdBillingRoute
  '/app/org/$orgId/customers/$customerId/edit': typeof AuthAppAppOrgOrgIdCustomersCustomerIdEditRoute
  '/app/org/$orgId/customers/$customerId/enrollments': typeof AuthAppAppOrgOrgIdCustomersCustomerIdEnrollmentsRoute
  '/app/org/$orgId/customers/$customerId/sessions': typeof AuthAppAppOrgOrgIdCustomersCustomerIdSessionsRoute
  '/app/org/$orgId/enrollments/$enrollmentId/billing': typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdBillingRoute
  '/app/org/$orgId/enrollments/$enrollmentId/edit': typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdEditRoute
  '/app/org/$orgId/schedules/$scheduleId/enrollments': typeof AuthAppAppOrgOrgIdSchedulesScheduleIdEnrollmentsRoute
  '/app/org/$orgId/schedules/$scheduleId/sessions': typeof AuthAppAppOrgOrgIdSchedulesScheduleIdSessionsRoute
  '/app/org/$orgId/settings/import/customers': typeof AuthAppAppOrgOrgIdSettingsImportCustomersRoute
  '/app/org/$orgId/staff/$staffId/edit': typeof AuthAppAppOrgOrgIdStaffStaffIdEditRoute
  '/app/org/$orgId/staff/$staffId/migrate-schedules': typeof AuthAppAppOrgOrgIdStaffStaffIdMigrateSchedulesRoute
  '/app/org/$orgId/staff/$staffId/permissions': typeof AuthAppAppOrgOrgIdStaffStaffIdPermissionsRoute
  '/app/org/$orgId/staff/$staffId/schedules': typeof AuthAppAppOrgOrgIdStaffStaffIdSchedulesRoute
  '/app/org/$orgId/billing/new/': typeof AuthAppAppOrgOrgIdBillingNewIndexRoute
  '/app/org/$orgId/customers/$customerId/': typeof AuthAppAppOrgOrgIdCustomersCustomerIdIndexRoute
  '/app/org/$orgId/events/birthday-reminder/': typeof AuthAppAppOrgOrgIdEventsBirthdayReminderIndexRoute
  '/app/org/$orgId/events/enrollment-expiry-reminder/': typeof AuthAppAppOrgOrgIdEventsEnrollmentExpiryReminderIndexRoute
  '/app/org/$orgId/org-management/cost-management/': typeof AuthAppAppOrgOrgIdOrgManagementCostManagementIndexRoute
  '/app/org/$orgId/org-management/customer-risk-analysis/': typeof AuthAppAppOrgOrgIdOrgManagementCustomerRiskAnalysisIndexRoute
  '/app/org/$orgId/org-management/financial-analysis/': typeof AuthAppAppOrgOrgIdOrgManagementFinancialAnalysisIndexRoute
  '/app/org/$orgId/schedules/$scheduleId/': typeof AuthAppAppOrgOrgIdSchedulesScheduleIdIndexRoute
  '/app/org/$orgId/settings/audit-events/': typeof AuthAppAppOrgOrgIdSettingsAuditEventsIndexRoute
  '/app/org/$orgId/settings/billing/': typeof AuthAppAppOrgOrgIdSettingsBillingIndexRoute
  '/app/org/$orgId/settings/features/': typeof AuthAppAppOrgOrgIdSettingsFeaturesIndexRoute
  '/app/org/$orgId/settings/import/': typeof AuthAppAppOrgOrgIdSettingsImportIndexRoute
  '/app/org/$orgId/settings/payment-methods/': typeof AuthAppAppOrgOrgIdSettingsPaymentMethodsIndexRoute
  '/app/org/$orgId/staff/$staffId/': typeof AuthAppAppOrgOrgIdStaffStaffIdIndexRoute
  '/app/org/$orgId/customers/$customerId/medicalRecords/new': typeof AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsNewRoute
  '/app/org/$orgId/customers/$customerId/medicalRecords/': typeof AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsIndexRoute
  '/app/org/$orgId/org-management/cost-management/categories/': typeof AuthAppAppOrgOrgIdOrgManagementCostManagementCategoriesIndexRoute
  '/app/org/$orgId/org-management/cost-management/expenses/': typeof AuthAppAppOrgOrgIdOrgManagementCostManagementExpensesIndexRoute
  '/app/org/$orgId/org-management/cost-management/recurring/': typeof AuthAppAppOrgOrgIdOrgManagementCostManagementRecurringIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof PublicIndexRoute
  '/about': typeof PublicAboutRoute
  '/pricing': typeof PublicPricingRoute
  '/privacy-policy': typeof PublicPrivacyPolicyRoute
  '/app/select-organization': typeof AuthAppSelectOrganizationRoute
  '/staff-invite/$token': typeof AuthStaffInviteTokenRoute
  '/sign-in/$': typeof PublicSignInSplatRoute
  '/sign-up/$': typeof PublicSignUpSplatRoute
  '/sign-in': typeof PublicSignInIndexRoute
  '/sign-up': typeof PublicSignUpIndexRoute
  '/app': typeof AuthAppAppIndexRoute
  '/app/org/renew-subscription': typeof AuthAppAppOrgRenewSubscriptionRoute
  '/app/help': typeof AuthAppAppHelpIndexRoute
  '/app/user-settings': typeof AuthAppAppUserSettingsIndexRoute
  '/app/help/user-guide/attendance-tracking': typeof AuthAppAppHelpUserGuideAttendanceTrackingRoute
  '/app/help/user-guide/customer-management': typeof AuthAppAppHelpUserGuideCustomerManagementRoute
  '/app/help/user-guide/customer-plans': typeof AuthAppAppHelpUserGuideCustomerPlansRoute
  '/app/help/user-guide/enrollment-process': typeof AuthAppAppHelpUserGuideEnrollmentProcessRoute
  '/app/help/user-guide/schedule-management': typeof AuthAppAppHelpUserGuideScheduleManagementRoute
  '/app/help/user-guide/staff-management': typeof AuthAppAppHelpUserGuideStaffManagementRoute
  '/app/org/$orgId/under_development': typeof AuthAppAppOrgOrgIdUnder_developmentRoute
  '/app/help/support': typeof AuthAppAppHelpSupportIndexRoute
  '/app/help/user-guide': typeof AuthAppAppHelpUserGuideIndexRoute
  '/app/org/$orgId': typeof AuthAppAppOrgOrgIdIndexRoute
  '/app/help/support/tickets/$ticketId': typeof AuthAppAppHelpSupportTicketsTicketIdRoute
  '/app/org/$orgId/billing/$invoiceId': typeof AuthAppAppOrgOrgIdBillingInvoiceIdRouteWithChildren
  '/app/org/$orgId/customers/new': typeof AuthAppAppOrgOrgIdCustomersNewRoute
  '/app/org/$orgId/enrollments/$enrollmentId': typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRouteWithChildren
  '/app/org/$orgId/enrollments/new': typeof AuthAppAppOrgOrgIdEnrollmentsNewRoute
  '/app/org/$orgId/schedules/new': typeof AuthAppAppOrgOrgIdSchedulesNewRoute
  '/app/help/support/tickets': typeof AuthAppAppHelpSupportTicketsIndexRoute
  '/app/org/$orgId/attendance': typeof AuthAppAppOrgOrgIdAttendanceIndexRoute
  '/app/org/$orgId/billing': typeof AuthAppAppOrgOrgIdBillingIndexRoute
  '/app/org/$orgId/customer-plans': typeof AuthAppAppOrgOrgIdCustomerPlansIndexRoute
  '/app/org/$orgId/customers': typeof AuthAppAppOrgOrgIdCustomersIndexRoute
  '/app/org/$orgId/enrollments': typeof AuthAppAppOrgOrgIdEnrollmentsIndexRoute
  '/app/org/$orgId/establishments': typeof AuthAppAppOrgOrgIdEstablishmentsIndexRoute
  '/app/org/$orgId/org-management': typeof AuthAppAppOrgOrgIdOrgManagementIndexRoute
  '/app/org/$orgId/schedules': typeof AuthAppAppOrgOrgIdSchedulesIndexRoute
  '/app/org/$orgId/settings': typeof AuthAppAppOrgOrgIdSettingsIndexRoute
  '/app/org/$orgId/staff': typeof AuthAppAppOrgOrgIdStaffIndexRoute
  '/app/org/$orgId/attendance/session/$sessionId': typeof AuthAppAppOrgOrgIdAttendanceSessionSessionIdRoute
  '/app/org/$orgId/billing/$invoiceId/disputes': typeof AuthAppAppOrgOrgIdBillingInvoiceIdDisputesRoute
  '/app/org/$orgId/billing/$invoiceId/overview': typeof AuthAppAppOrgOrgIdBillingInvoiceIdOverviewRoute
  '/app/org/$orgId/billing/$invoiceId/payments': typeof AuthAppAppOrgOrgIdBillingInvoiceIdPaymentsRoute
  '/app/org/$orgId/billing/$invoiceId/refunds': typeof AuthAppAppOrgOrgIdBillingInvoiceIdRefundsRoute
  '/app/org/$orgId/customers/$customerId/billing': typeof AuthAppAppOrgOrgIdCustomersCustomerIdBillingRoute
  '/app/org/$orgId/customers/$customerId/edit': typeof AuthAppAppOrgOrgIdCustomersCustomerIdEditRoute
  '/app/org/$orgId/customers/$customerId/enrollments': typeof AuthAppAppOrgOrgIdCustomersCustomerIdEnrollmentsRoute
  '/app/org/$orgId/customers/$customerId/sessions': typeof AuthAppAppOrgOrgIdCustomersCustomerIdSessionsRoute
  '/app/org/$orgId/enrollments/$enrollmentId/billing': typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdBillingRoute
  '/app/org/$orgId/enrollments/$enrollmentId/edit': typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdEditRoute
  '/app/org/$orgId/schedules/$scheduleId/enrollments': typeof AuthAppAppOrgOrgIdSchedulesScheduleIdEnrollmentsRoute
  '/app/org/$orgId/schedules/$scheduleId/sessions': typeof AuthAppAppOrgOrgIdSchedulesScheduleIdSessionsRoute
  '/app/org/$orgId/settings/import/customers': typeof AuthAppAppOrgOrgIdSettingsImportCustomersRoute
  '/app/org/$orgId/staff/$staffId/edit': typeof AuthAppAppOrgOrgIdStaffStaffIdEditRoute
  '/app/org/$orgId/staff/$staffId/migrate-schedules': typeof AuthAppAppOrgOrgIdStaffStaffIdMigrateSchedulesRoute
  '/app/org/$orgId/staff/$staffId/permissions': typeof AuthAppAppOrgOrgIdStaffStaffIdPermissionsRoute
  '/app/org/$orgId/staff/$staffId/schedules': typeof AuthAppAppOrgOrgIdStaffStaffIdSchedulesRoute
  '/app/org/$orgId/billing/new': typeof AuthAppAppOrgOrgIdBillingNewIndexRoute
  '/app/org/$orgId/customers/$customerId': typeof AuthAppAppOrgOrgIdCustomersCustomerIdIndexRoute
  '/app/org/$orgId/events/birthday-reminder': typeof AuthAppAppOrgOrgIdEventsBirthdayReminderIndexRoute
  '/app/org/$orgId/events/enrollment-expiry-reminder': typeof AuthAppAppOrgOrgIdEventsEnrollmentExpiryReminderIndexRoute
  '/app/org/$orgId/org-management/cost-management': typeof AuthAppAppOrgOrgIdOrgManagementCostManagementIndexRoute
  '/app/org/$orgId/org-management/customer-risk-analysis': typeof AuthAppAppOrgOrgIdOrgManagementCustomerRiskAnalysisIndexRoute
  '/app/org/$orgId/org-management/financial-analysis': typeof AuthAppAppOrgOrgIdOrgManagementFinancialAnalysisIndexRoute
  '/app/org/$orgId/schedules/$scheduleId': typeof AuthAppAppOrgOrgIdSchedulesScheduleIdIndexRoute
  '/app/org/$orgId/settings/audit-events': typeof AuthAppAppOrgOrgIdSettingsAuditEventsIndexRoute
  '/app/org/$orgId/settings/billing': typeof AuthAppAppOrgOrgIdSettingsBillingIndexRoute
  '/app/org/$orgId/settings/features': typeof AuthAppAppOrgOrgIdSettingsFeaturesIndexRoute
  '/app/org/$orgId/settings/import': typeof AuthAppAppOrgOrgIdSettingsImportIndexRoute
  '/app/org/$orgId/settings/payment-methods': typeof AuthAppAppOrgOrgIdSettingsPaymentMethodsIndexRoute
  '/app/org/$orgId/staff/$staffId': typeof AuthAppAppOrgOrgIdStaffStaffIdIndexRoute
  '/app/org/$orgId/customers/$customerId/medicalRecords/new': typeof AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsNewRoute
  '/app/org/$orgId/customers/$customerId/medicalRecords': typeof AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsIndexRoute
  '/app/org/$orgId/org-management/cost-management/categories': typeof AuthAppAppOrgOrgIdOrgManagementCostManagementCategoriesIndexRoute
  '/app/org/$orgId/org-management/cost-management/expenses': typeof AuthAppAppOrgOrgIdOrgManagementCostManagementExpensesIndexRoute
  '/app/org/$orgId/org-management/cost-management/recurring': typeof AuthAppAppOrgOrgIdOrgManagementCostManagementRecurringIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_public/about': typeof PublicAboutRoute
  '/_public/pricing': typeof PublicPricingRoute
  '/_public/privacy-policy': typeof PublicPrivacyPolicyRoute
  '/_public/': typeof PublicIndexRoute
  '/_auth/app/_app': typeof AuthAppAppRouteWithChildren
  '/_auth/app/select-organization': typeof AuthAppSelectOrganizationRoute
  '/_auth/staff-invite/$token': typeof AuthStaffInviteTokenRoute
  '/_public/sign-in/$': typeof PublicSignInSplatRoute
  '/_public/sign-up/$': typeof PublicSignUpSplatRoute
  '/_public/sign-in/': typeof PublicSignInIndexRoute
  '/_public/sign-up/': typeof PublicSignUpIndexRoute
  '/_auth/app/_app/help': typeof AuthAppAppHelpRouteWithChildren
  '/_auth/app/_app/': typeof AuthAppAppIndexRoute
  '/_auth/app/_app/help/support': typeof AuthAppAppHelpSupportRouteWithChildren
  '/_auth/app/_app/help/user-guide': typeof AuthAppAppHelpUserGuideRouteWithChildren
  '/_auth/app/_app/org/$orgId': typeof AuthAppAppOrgOrgIdRouteWithChildren
  '/_auth/app/_app/org/renew-subscription': typeof AuthAppAppOrgRenewSubscriptionRoute
  '/_auth/app/_app/help/': typeof AuthAppAppHelpIndexRoute
  '/_auth/app/_app/user-settings/': typeof AuthAppAppUserSettingsIndexRoute
  '/_auth/app/_app/help/user-guide/attendance-tracking': typeof AuthAppAppHelpUserGuideAttendanceTrackingRoute
  '/_auth/app/_app/help/user-guide/customer-management': typeof AuthAppAppHelpUserGuideCustomerManagementRoute
  '/_auth/app/_app/help/user-guide/customer-plans': typeof AuthAppAppHelpUserGuideCustomerPlansRoute
  '/_auth/app/_app/help/user-guide/enrollment-process': typeof AuthAppAppHelpUserGuideEnrollmentProcessRoute
  '/_auth/app/_app/help/user-guide/schedule-management': typeof AuthAppAppHelpUserGuideScheduleManagementRoute
  '/_auth/app/_app/help/user-guide/staff-management': typeof AuthAppAppHelpUserGuideStaffManagementRoute
  '/_auth/app/_app/org/$orgId/attendance': typeof AuthAppAppOrgOrgIdAttendanceRouteWithChildren
  '/_auth/app/_app/org/$orgId/customers': typeof AuthAppAppOrgOrgIdCustomersRouteWithChildren
  '/_auth/app/_app/org/$orgId/under_development': typeof AuthAppAppOrgOrgIdUnder_developmentRoute
  '/_auth/app/_app/help/support/': typeof AuthAppAppHelpSupportIndexRoute
  '/_auth/app/_app/help/user-guide/': typeof AuthAppAppHelpUserGuideIndexRoute
  '/_auth/app/_app/org/$orgId/': typeof AuthAppAppOrgOrgIdIndexRoute
  '/_auth/app/_app/help/support/tickets/$ticketId': typeof AuthAppAppHelpSupportTicketsTicketIdRoute
  '/_auth/app/_app/org/$orgId/billing/$invoiceId': typeof AuthAppAppOrgOrgIdBillingInvoiceIdRouteWithChildren
  '/_auth/app/_app/org/$orgId/customers/$customerId': typeof AuthAppAppOrgOrgIdCustomersCustomerIdRouteWithChildren
  '/_auth/app/_app/org/$orgId/customers/new': typeof AuthAppAppOrgOrgIdCustomersNewRoute
  '/_auth/app/_app/org/$orgId/enrollments/$enrollmentId': typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRouteWithChildren
  '/_auth/app/_app/org/$orgId/enrollments/new': typeof AuthAppAppOrgOrgIdEnrollmentsNewRoute
  '/_auth/app/_app/org/$orgId/schedules/$scheduleId': typeof AuthAppAppOrgOrgIdSchedulesScheduleIdRouteWithChildren
  '/_auth/app/_app/org/$orgId/schedules/new': typeof AuthAppAppOrgOrgIdSchedulesNewRoute
  '/_auth/app/_app/org/$orgId/staff/$staffId': typeof AuthAppAppOrgOrgIdStaffStaffIdRouteWithChildren
  '/_auth/app/_app/help/support/tickets/': typeof AuthAppAppHelpSupportTicketsIndexRoute
  '/_auth/app/_app/org/$orgId/attendance/': typeof AuthAppAppOrgOrgIdAttendanceIndexRoute
  '/_auth/app/_app/org/$orgId/billing/': typeof AuthAppAppOrgOrgIdBillingIndexRoute
  '/_auth/app/_app/org/$orgId/customer-plans/': typeof AuthAppAppOrgOrgIdCustomerPlansIndexRoute
  '/_auth/app/_app/org/$orgId/customers/': typeof AuthAppAppOrgOrgIdCustomersIndexRoute
  '/_auth/app/_app/org/$orgId/enrollments/': typeof AuthAppAppOrgOrgIdEnrollmentsIndexRoute
  '/_auth/app/_app/org/$orgId/establishments/': typeof AuthAppAppOrgOrgIdEstablishmentsIndexRoute
  '/_auth/app/_app/org/$orgId/org-management/': typeof AuthAppAppOrgOrgIdOrgManagementIndexRoute
  '/_auth/app/_app/org/$orgId/schedules/': typeof AuthAppAppOrgOrgIdSchedulesIndexRoute
  '/_auth/app/_app/org/$orgId/settings/': typeof AuthAppAppOrgOrgIdSettingsIndexRoute
  '/_auth/app/_app/org/$orgId/staff/': typeof AuthAppAppOrgOrgIdStaffIndexRoute
  '/_auth/app/_app/org/$orgId/attendance/session/$sessionId': typeof AuthAppAppOrgOrgIdAttendanceSessionSessionIdRoute
  '/_auth/app/_app/org/$orgId/billing/$invoiceId/disputes': typeof AuthAppAppOrgOrgIdBillingInvoiceIdDisputesRoute
  '/_auth/app/_app/org/$orgId/billing/$invoiceId/overview': typeof AuthAppAppOrgOrgIdBillingInvoiceIdOverviewRoute
  '/_auth/app/_app/org/$orgId/billing/$invoiceId/payments': typeof AuthAppAppOrgOrgIdBillingInvoiceIdPaymentsRoute
  '/_auth/app/_app/org/$orgId/billing/$invoiceId/refunds': typeof AuthAppAppOrgOrgIdBillingInvoiceIdRefundsRoute
  '/_auth/app/_app/org/$orgId/customers/$customerId/billing': typeof AuthAppAppOrgOrgIdCustomersCustomerIdBillingRoute
  '/_auth/app/_app/org/$orgId/customers/$customerId/edit': typeof AuthAppAppOrgOrgIdCustomersCustomerIdEditRoute
  '/_auth/app/_app/org/$orgId/customers/$customerId/enrollments': typeof AuthAppAppOrgOrgIdCustomersCustomerIdEnrollmentsRoute
  '/_auth/app/_app/org/$orgId/customers/$customerId/sessions': typeof AuthAppAppOrgOrgIdCustomersCustomerIdSessionsRoute
  '/_auth/app/_app/org/$orgId/enrollments/$enrollmentId/billing': typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdBillingRoute
  '/_auth/app/_app/org/$orgId/enrollments/$enrollmentId/edit': typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdEditRoute
  '/_auth/app/_app/org/$orgId/schedules/$scheduleId/enrollments': typeof AuthAppAppOrgOrgIdSchedulesScheduleIdEnrollmentsRoute
  '/_auth/app/_app/org/$orgId/schedules/$scheduleId/sessions': typeof AuthAppAppOrgOrgIdSchedulesScheduleIdSessionsRoute
  '/_auth/app/_app/org/$orgId/settings/import/customers': typeof AuthAppAppOrgOrgIdSettingsImportCustomersRoute
  '/_auth/app/_app/org/$orgId/staff/$staffId/edit': typeof AuthAppAppOrgOrgIdStaffStaffIdEditRoute
  '/_auth/app/_app/org/$orgId/staff/$staffId/migrate-schedules': typeof AuthAppAppOrgOrgIdStaffStaffIdMigrateSchedulesRoute
  '/_auth/app/_app/org/$orgId/staff/$staffId/permissions': typeof AuthAppAppOrgOrgIdStaffStaffIdPermissionsRoute
  '/_auth/app/_app/org/$orgId/staff/$staffId/schedules': typeof AuthAppAppOrgOrgIdStaffStaffIdSchedulesRoute
  '/_auth/app/_app/org/$orgId/billing/new/': typeof AuthAppAppOrgOrgIdBillingNewIndexRoute
  '/_auth/app/_app/org/$orgId/customers/$customerId/': typeof AuthAppAppOrgOrgIdCustomersCustomerIdIndexRoute
  '/_auth/app/_app/org/$orgId/events/birthday-reminder/': typeof AuthAppAppOrgOrgIdEventsBirthdayReminderIndexRoute
  '/_auth/app/_app/org/$orgId/events/enrollment-expiry-reminder/': typeof AuthAppAppOrgOrgIdEventsEnrollmentExpiryReminderIndexRoute
  '/_auth/app/_app/org/$orgId/org-management/cost-management/': typeof AuthAppAppOrgOrgIdOrgManagementCostManagementIndexRoute
  '/_auth/app/_app/org/$orgId/org-management/customer-risk-analysis/': typeof AuthAppAppOrgOrgIdOrgManagementCustomerRiskAnalysisIndexRoute
  '/_auth/app/_app/org/$orgId/org-management/financial-analysis/': typeof AuthAppAppOrgOrgIdOrgManagementFinancialAnalysisIndexRoute
  '/_auth/app/_app/org/$orgId/schedules/$scheduleId/': typeof AuthAppAppOrgOrgIdSchedulesScheduleIdIndexRoute
  '/_auth/app/_app/org/$orgId/settings/audit-events/': typeof AuthAppAppOrgOrgIdSettingsAuditEventsIndexRoute
  '/_auth/app/_app/org/$orgId/settings/billing/': typeof AuthAppAppOrgOrgIdSettingsBillingIndexRoute
  '/_auth/app/_app/org/$orgId/settings/features/': typeof AuthAppAppOrgOrgIdSettingsFeaturesIndexRoute
  '/_auth/app/_app/org/$orgId/settings/import/': typeof AuthAppAppOrgOrgIdSettingsImportIndexRoute
  '/_auth/app/_app/org/$orgId/settings/payment-methods/': typeof AuthAppAppOrgOrgIdSettingsPaymentMethodsIndexRoute
  '/_auth/app/_app/org/$orgId/staff/$staffId/': typeof AuthAppAppOrgOrgIdStaffStaffIdIndexRoute
  '/_auth/app/_app/org/$orgId/customers/$customerId/medicalRecords/new': typeof AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsNewRoute
  '/_auth/app/_app/org/$orgId/customers/$customerId/medicalRecords/': typeof AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsIndexRoute
  '/_auth/app/_app/org/$orgId/org-management/cost-management/categories/': typeof AuthAppAppOrgOrgIdOrgManagementCostManagementCategoriesIndexRoute
  '/_auth/app/_app/org/$orgId/org-management/cost-management/expenses/': typeof AuthAppAppOrgOrgIdOrgManagementCostManagementExpensesIndexRoute
  '/_auth/app/_app/org/$orgId/org-management/cost-management/recurring/': typeof AuthAppAppOrgOrgIdOrgManagementCostManagementRecurringIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/pricing'
    | '/privacy-policy'
    | '/app'
    | '/app/select-organization'
    | '/staff-invite/$token'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/sign-in/'
    | '/sign-up/'
    | '/app/help'
    | '/app/'
    | '/app/help/support'
    | '/app/help/user-guide'
    | '/app/org/$orgId'
    | '/app/org/renew-subscription'
    | '/app/help/'
    | '/app/user-settings/'
    | '/app/help/user-guide/attendance-tracking'
    | '/app/help/user-guide/customer-management'
    | '/app/help/user-guide/customer-plans'
    | '/app/help/user-guide/enrollment-process'
    | '/app/help/user-guide/schedule-management'
    | '/app/help/user-guide/staff-management'
    | '/app/org/$orgId/attendance'
    | '/app/org/$orgId/customers'
    | '/app/org/$orgId/under_development'
    | '/app/help/support/'
    | '/app/help/user-guide/'
    | '/app/org/$orgId/'
    | '/app/help/support/tickets/$ticketId'
    | '/app/org/$orgId/billing/$invoiceId'
    | '/app/org/$orgId/customers/$customerId'
    | '/app/org/$orgId/customers/new'
    | '/app/org/$orgId/enrollments/$enrollmentId'
    | '/app/org/$orgId/enrollments/new'
    | '/app/org/$orgId/schedules/$scheduleId'
    | '/app/org/$orgId/schedules/new'
    | '/app/org/$orgId/staff/$staffId'
    | '/app/help/support/tickets/'
    | '/app/org/$orgId/attendance/'
    | '/app/org/$orgId/billing/'
    | '/app/org/$orgId/customer-plans/'
    | '/app/org/$orgId/customers/'
    | '/app/org/$orgId/enrollments/'
    | '/app/org/$orgId/establishments/'
    | '/app/org/$orgId/org-management/'
    | '/app/org/$orgId/schedules/'
    | '/app/org/$orgId/settings/'
    | '/app/org/$orgId/staff/'
    | '/app/org/$orgId/attendance/session/$sessionId'
    | '/app/org/$orgId/billing/$invoiceId/disputes'
    | '/app/org/$orgId/billing/$invoiceId/overview'
    | '/app/org/$orgId/billing/$invoiceId/payments'
    | '/app/org/$orgId/billing/$invoiceId/refunds'
    | '/app/org/$orgId/customers/$customerId/billing'
    | '/app/org/$orgId/customers/$customerId/edit'
    | '/app/org/$orgId/customers/$customerId/enrollments'
    | '/app/org/$orgId/customers/$customerId/sessions'
    | '/app/org/$orgId/enrollments/$enrollmentId/billing'
    | '/app/org/$orgId/enrollments/$enrollmentId/edit'
    | '/app/org/$orgId/schedules/$scheduleId/enrollments'
    | '/app/org/$orgId/schedules/$scheduleId/sessions'
    | '/app/org/$orgId/settings/import/customers'
    | '/app/org/$orgId/staff/$staffId/edit'
    | '/app/org/$orgId/staff/$staffId/migrate-schedules'
    | '/app/org/$orgId/staff/$staffId/permissions'
    | '/app/org/$orgId/staff/$staffId/schedules'
    | '/app/org/$orgId/billing/new/'
    | '/app/org/$orgId/customers/$customerId/'
    | '/app/org/$orgId/events/birthday-reminder/'
    | '/app/org/$orgId/events/enrollment-expiry-reminder/'
    | '/app/org/$orgId/org-management/cost-management/'
    | '/app/org/$orgId/org-management/customer-risk-analysis/'
    | '/app/org/$orgId/org-management/financial-analysis/'
    | '/app/org/$orgId/schedules/$scheduleId/'
    | '/app/org/$orgId/settings/audit-events/'
    | '/app/org/$orgId/settings/billing/'
    | '/app/org/$orgId/settings/features/'
    | '/app/org/$orgId/settings/import/'
    | '/app/org/$orgId/settings/payment-methods/'
    | '/app/org/$orgId/staff/$staffId/'
    | '/app/org/$orgId/customers/$customerId/medicalRecords/new'
    | '/app/org/$orgId/customers/$customerId/medicalRecords/'
    | '/app/org/$orgId/org-management/cost-management/categories/'
    | '/app/org/$orgId/org-management/cost-management/expenses/'
    | '/app/org/$orgId/org-management/cost-management/recurring/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/pricing'
    | '/privacy-policy'
    | '/app/select-organization'
    | '/staff-invite/$token'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/sign-in'
    | '/sign-up'
    | '/app'
    | '/app/org/renew-subscription'
    | '/app/help'
    | '/app/user-settings'
    | '/app/help/user-guide/attendance-tracking'
    | '/app/help/user-guide/customer-management'
    | '/app/help/user-guide/customer-plans'
    | '/app/help/user-guide/enrollment-process'
    | '/app/help/user-guide/schedule-management'
    | '/app/help/user-guide/staff-management'
    | '/app/org/$orgId/under_development'
    | '/app/help/support'
    | '/app/help/user-guide'
    | '/app/org/$orgId'
    | '/app/help/support/tickets/$ticketId'
    | '/app/org/$orgId/billing/$invoiceId'
    | '/app/org/$orgId/customers/new'
    | '/app/org/$orgId/enrollments/$enrollmentId'
    | '/app/org/$orgId/enrollments/new'
    | '/app/org/$orgId/schedules/new'
    | '/app/help/support/tickets'
    | '/app/org/$orgId/attendance'
    | '/app/org/$orgId/billing'
    | '/app/org/$orgId/customer-plans'
    | '/app/org/$orgId/customers'
    | '/app/org/$orgId/enrollments'
    | '/app/org/$orgId/establishments'
    | '/app/org/$orgId/org-management'
    | '/app/org/$orgId/schedules'
    | '/app/org/$orgId/settings'
    | '/app/org/$orgId/staff'
    | '/app/org/$orgId/attendance/session/$sessionId'
    | '/app/org/$orgId/billing/$invoiceId/disputes'
    | '/app/org/$orgId/billing/$invoiceId/overview'
    | '/app/org/$orgId/billing/$invoiceId/payments'
    | '/app/org/$orgId/billing/$invoiceId/refunds'
    | '/app/org/$orgId/customers/$customerId/billing'
    | '/app/org/$orgId/customers/$customerId/edit'
    | '/app/org/$orgId/customers/$customerId/enrollments'
    | '/app/org/$orgId/customers/$customerId/sessions'
    | '/app/org/$orgId/enrollments/$enrollmentId/billing'
    | '/app/org/$orgId/enrollments/$enrollmentId/edit'
    | '/app/org/$orgId/schedules/$scheduleId/enrollments'
    | '/app/org/$orgId/schedules/$scheduleId/sessions'
    | '/app/org/$orgId/settings/import/customers'
    | '/app/org/$orgId/staff/$staffId/edit'
    | '/app/org/$orgId/staff/$staffId/migrate-schedules'
    | '/app/org/$orgId/staff/$staffId/permissions'
    | '/app/org/$orgId/staff/$staffId/schedules'
    | '/app/org/$orgId/billing/new'
    | '/app/org/$orgId/customers/$customerId'
    | '/app/org/$orgId/events/birthday-reminder'
    | '/app/org/$orgId/events/enrollment-expiry-reminder'
    | '/app/org/$orgId/org-management/cost-management'
    | '/app/org/$orgId/org-management/customer-risk-analysis'
    | '/app/org/$orgId/org-management/financial-analysis'
    | '/app/org/$orgId/schedules/$scheduleId'
    | '/app/org/$orgId/settings/audit-events'
    | '/app/org/$orgId/settings/billing'
    | '/app/org/$orgId/settings/features'
    | '/app/org/$orgId/settings/import'
    | '/app/org/$orgId/settings/payment-methods'
    | '/app/org/$orgId/staff/$staffId'
    | '/app/org/$orgId/customers/$customerId/medicalRecords/new'
    | '/app/org/$orgId/customers/$customerId/medicalRecords'
    | '/app/org/$orgId/org-management/cost-management/categories'
    | '/app/org/$orgId/org-management/cost-management/expenses'
    | '/app/org/$orgId/org-management/cost-management/recurring'
  id:
    | '__root__'
    | '/_auth'
    | '/_public'
    | '/_public/about'
    | '/_public/pricing'
    | '/_public/privacy-policy'
    | '/_public/'
    | '/_auth/app/_app'
    | '/_auth/app/select-organization'
    | '/_auth/staff-invite/$token'
    | '/_public/sign-in/$'
    | '/_public/sign-up/$'
    | '/_public/sign-in/'
    | '/_public/sign-up/'
    | '/_auth/app/_app/help'
    | '/_auth/app/_app/'
    | '/_auth/app/_app/help/support'
    | '/_auth/app/_app/help/user-guide'
    | '/_auth/app/_app/org/$orgId'
    | '/_auth/app/_app/org/renew-subscription'
    | '/_auth/app/_app/help/'
    | '/_auth/app/_app/user-settings/'
    | '/_auth/app/_app/help/user-guide/attendance-tracking'
    | '/_auth/app/_app/help/user-guide/customer-management'
    | '/_auth/app/_app/help/user-guide/customer-plans'
    | '/_auth/app/_app/help/user-guide/enrollment-process'
    | '/_auth/app/_app/help/user-guide/schedule-management'
    | '/_auth/app/_app/help/user-guide/staff-management'
    | '/_auth/app/_app/org/$orgId/attendance'
    | '/_auth/app/_app/org/$orgId/customers'
    | '/_auth/app/_app/org/$orgId/under_development'
    | '/_auth/app/_app/help/support/'
    | '/_auth/app/_app/help/user-guide/'
    | '/_auth/app/_app/org/$orgId/'
    | '/_auth/app/_app/help/support/tickets/$ticketId'
    | '/_auth/app/_app/org/$orgId/billing/$invoiceId'
    | '/_auth/app/_app/org/$orgId/customers/$customerId'
    | '/_auth/app/_app/org/$orgId/customers/new'
    | '/_auth/app/_app/org/$orgId/enrollments/$enrollmentId'
    | '/_auth/app/_app/org/$orgId/enrollments/new'
    | '/_auth/app/_app/org/$orgId/schedules/$scheduleId'
    | '/_auth/app/_app/org/$orgId/schedules/new'
    | '/_auth/app/_app/org/$orgId/staff/$staffId'
    | '/_auth/app/_app/help/support/tickets/'
    | '/_auth/app/_app/org/$orgId/attendance/'
    | '/_auth/app/_app/org/$orgId/billing/'
    | '/_auth/app/_app/org/$orgId/customer-plans/'
    | '/_auth/app/_app/org/$orgId/customers/'
    | '/_auth/app/_app/org/$orgId/enrollments/'
    | '/_auth/app/_app/org/$orgId/establishments/'
    | '/_auth/app/_app/org/$orgId/org-management/'
    | '/_auth/app/_app/org/$orgId/schedules/'
    | '/_auth/app/_app/org/$orgId/settings/'
    | '/_auth/app/_app/org/$orgId/staff/'
    | '/_auth/app/_app/org/$orgId/attendance/session/$sessionId'
    | '/_auth/app/_app/org/$orgId/billing/$invoiceId/disputes'
    | '/_auth/app/_app/org/$orgId/billing/$invoiceId/overview'
    | '/_auth/app/_app/org/$orgId/billing/$invoiceId/payments'
    | '/_auth/app/_app/org/$orgId/billing/$invoiceId/refunds'
    | '/_auth/app/_app/org/$orgId/customers/$customerId/billing'
    | '/_auth/app/_app/org/$orgId/customers/$customerId/edit'
    | '/_auth/app/_app/org/$orgId/customers/$customerId/enrollments'
    | '/_auth/app/_app/org/$orgId/customers/$customerId/sessions'
    | '/_auth/app/_app/org/$orgId/enrollments/$enrollmentId/billing'
    | '/_auth/app/_app/org/$orgId/enrollments/$enrollmentId/edit'
    | '/_auth/app/_app/org/$orgId/schedules/$scheduleId/enrollments'
    | '/_auth/app/_app/org/$orgId/schedules/$scheduleId/sessions'
    | '/_auth/app/_app/org/$orgId/settings/import/customers'
    | '/_auth/app/_app/org/$orgId/staff/$staffId/edit'
    | '/_auth/app/_app/org/$orgId/staff/$staffId/migrate-schedules'
    | '/_auth/app/_app/org/$orgId/staff/$staffId/permissions'
    | '/_auth/app/_app/org/$orgId/staff/$staffId/schedules'
    | '/_auth/app/_app/org/$orgId/billing/new/'
    | '/_auth/app/_app/org/$orgId/customers/$customerId/'
    | '/_auth/app/_app/org/$orgId/events/birthday-reminder/'
    | '/_auth/app/_app/org/$orgId/events/enrollment-expiry-reminder/'
    | '/_auth/app/_app/org/$orgId/org-management/cost-management/'
    | '/_auth/app/_app/org/$orgId/org-management/customer-risk-analysis/'
    | '/_auth/app/_app/org/$orgId/org-management/financial-analysis/'
    | '/_auth/app/_app/org/$orgId/schedules/$scheduleId/'
    | '/_auth/app/_app/org/$orgId/settings/audit-events/'
    | '/_auth/app/_app/org/$orgId/settings/billing/'
    | '/_auth/app/_app/org/$orgId/settings/features/'
    | '/_auth/app/_app/org/$orgId/settings/import/'
    | '/_auth/app/_app/org/$orgId/settings/payment-methods/'
    | '/_auth/app/_app/org/$orgId/staff/$staffId/'
    | '/_auth/app/_app/org/$orgId/customers/$customerId/medicalRecords/new'
    | '/_auth/app/_app/org/$orgId/customers/$customerId/medicalRecords/'
    | '/_auth/app/_app/org/$orgId/org-management/cost-management/categories/'
    | '/_auth/app/_app/org/$orgId/org-management/cost-management/expenses/'
    | '/_auth/app/_app/org/$orgId/org-management/cost-management/recurring/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/privacy-policy': {
      id: '/_public/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PublicPrivacyPolicyRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/pricing': {
      id: '/_public/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PublicPricingRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/about': {
      id: '/_public/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof PublicAboutRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-up/': {
      id: '/_public/sign-up/'
      path: '/sign-up'
      fullPath: '/sign-up/'
      preLoaderRoute: typeof PublicSignUpIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-in/': {
      id: '/_public/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in/'
      preLoaderRoute: typeof PublicSignInIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-up/$': {
      id: '/_public/sign-up/$'
      path: '/sign-up/$'
      fullPath: '/sign-up/$'
      preLoaderRoute: typeof PublicSignUpSplatRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-in/$': {
      id: '/_public/sign-in/$'
      path: '/sign-in/$'
      fullPath: '/sign-in/$'
      preLoaderRoute: typeof PublicSignInSplatRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/staff-invite/$token': {
      id: '/_auth/staff-invite/$token'
      path: '/staff-invite/$token'
      fullPath: '/staff-invite/$token'
      preLoaderRoute: typeof AuthStaffInviteTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/app/select-organization': {
      id: '/_auth/app/select-organization'
      path: '/app/select-organization'
      fullPath: '/app/select-organization'
      preLoaderRoute: typeof AuthAppSelectOrganizationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/app/_app': {
      id: '/_auth/app/_app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AuthAppAppRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/app/_app/': {
      id: '/_auth/app/_app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AuthAppAppIndexRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/help': {
      id: '/_auth/app/_app/help'
      path: '/help'
      fullPath: '/app/help'
      preLoaderRoute: typeof AuthAppAppHelpRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/user-settings/': {
      id: '/_auth/app/_app/user-settings/'
      path: '/user-settings'
      fullPath: '/app/user-settings/'
      preLoaderRoute: typeof AuthAppAppUserSettingsIndexRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/help/': {
      id: '/_auth/app/_app/help/'
      path: '/'
      fullPath: '/app/help/'
      preLoaderRoute: typeof AuthAppAppHelpIndexRouteImport
      parentRoute: typeof AuthAppAppHelpRoute
    }
    '/_auth/app/_app/org/renew-subscription': {
      id: '/_auth/app/_app/org/renew-subscription'
      path: '/org/renew-subscription'
      fullPath: '/app/org/renew-subscription'
      preLoaderRoute: typeof AuthAppAppOrgRenewSubscriptionRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/org/$orgId': {
      id: '/_auth/app/_app/org/$orgId'
      path: '/org/$orgId'
      fullPath: '/app/org/$orgId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/help/user-guide': {
      id: '/_auth/app/_app/help/user-guide'
      path: '/user-guide'
      fullPath: '/app/help/user-guide'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideRouteImport
      parentRoute: typeof AuthAppAppHelpRoute
    }
    '/_auth/app/_app/help/support': {
      id: '/_auth/app/_app/help/support'
      path: '/support'
      fullPath: '/app/help/support'
      preLoaderRoute: typeof AuthAppAppHelpSupportRouteImport
      parentRoute: typeof AuthAppAppHelpRoute
    }
    '/_auth/app/_app/org/$orgId/': {
      id: '/_auth/app/_app/org/$orgId/'
      path: '/'
      fullPath: '/app/org/$orgId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/help/user-guide/': {
      id: '/_auth/app/_app/help/user-guide/'
      path: '/'
      fullPath: '/app/help/user-guide/'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideIndexRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/help/support/': {
      id: '/_auth/app/_app/help/support/'
      path: '/'
      fullPath: '/app/help/support/'
      preLoaderRoute: typeof AuthAppAppHelpSupportIndexRouteImport
      parentRoute: typeof AuthAppAppHelpSupportRoute
    }
    '/_auth/app/_app/org/$orgId/under_development': {
      id: '/_auth/app/_app/org/$orgId/under_development'
      path: '/under_development'
      fullPath: '/app/org/$orgId/under_development'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdUnder_developmentRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/customers': {
      id: '/_auth/app/_app/org/$orgId/customers'
      path: '/customers'
      fullPath: '/app/org/$orgId/customers'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdCustomersRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/attendance': {
      id: '/_auth/app/_app/org/$orgId/attendance'
      path: '/attendance'
      fullPath: '/app/org/$orgId/attendance'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdAttendanceRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/help/user-guide/staff-management': {
      id: '/_auth/app/_app/help/user-guide/staff-management'
      path: '/staff-management'
      fullPath: '/app/help/user-guide/staff-management'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideStaffManagementRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/help/user-guide/schedule-management': {
      id: '/_auth/app/_app/help/user-guide/schedule-management'
      path: '/schedule-management'
      fullPath: '/app/help/user-guide/schedule-management'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideScheduleManagementRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/help/user-guide/enrollment-process': {
      id: '/_auth/app/_app/help/user-guide/enrollment-process'
      path: '/enrollment-process'
      fullPath: '/app/help/user-guide/enrollment-process'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideEnrollmentProcessRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/help/user-guide/customer-plans': {
      id: '/_auth/app/_app/help/user-guide/customer-plans'
      path: '/customer-plans'
      fullPath: '/app/help/user-guide/customer-plans'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideCustomerPlansRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/help/user-guide/customer-management': {
      id: '/_auth/app/_app/help/user-guide/customer-management'
      path: '/customer-management'
      fullPath: '/app/help/user-guide/customer-management'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideCustomerManagementRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/help/user-guide/attendance-tracking': {
      id: '/_auth/app/_app/help/user-guide/attendance-tracking'
      path: '/attendance-tracking'
      fullPath: '/app/help/user-guide/attendance-tracking'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideAttendanceTrackingRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/org/$orgId/staff/': {
      id: '/_auth/app/_app/org/$orgId/staff/'
      path: '/staff'
      fullPath: '/app/org/$orgId/staff/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdStaffIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/settings/': {
      id: '/_auth/app/_app/org/$orgId/settings/'
      path: '/settings'
      fullPath: '/app/org/$orgId/settings/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/schedules/': {
      id: '/_auth/app/_app/org/$orgId/schedules/'
      path: '/schedules'
      fullPath: '/app/org/$orgId/schedules/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSchedulesIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/org-management/': {
      id: '/_auth/app/_app/org/$orgId/org-management/'
      path: '/org-management'
      fullPath: '/app/org/$orgId/org-management/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdOrgManagementIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/establishments/': {
      id: '/_auth/app/_app/org/$orgId/establishments/'
      path: '/establishments'
      fullPath: '/app/org/$orgId/establishments/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEstablishmentsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/enrollments/': {
      id: '/_auth/app/_app/org/$orgId/enrollments/'
      path: '/enrollments'
      fullPath: '/app/org/$orgId/enrollments/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEnrollmentsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/customers/': {
      id: '/_auth/app/_app/org/$orgId/customers/'
      path: '/'
      fullPath: '/app/org/$orgId/customers/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdCustomersIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdCustomersRoute
    }
    '/_auth/app/_app/org/$orgId/customer-plans/': {
      id: '/_auth/app/_app/org/$orgId/customer-plans/'
      path: '/customer-plans'
      fullPath: '/app/org/$orgId/customer-plans/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdCustomerPlansIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/billing/': {
      id: '/_auth/app/_app/org/$orgId/billing/'
      path: '/billing'
      fullPath: '/app/org/$orgId/billing/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdBillingIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/attendance/': {
      id: '/_auth/app/_app/org/$orgId/attendance/'
      path: '/'
      fullPath: '/app/org/$orgId/attendance/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdAttendanceIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdAttendanceRoute
    }
    '/_auth/app/_app/help/support/tickets/': {
      id: '/_auth/app/_app/help/support/tickets/'
      path: '/tickets'
      fullPath: '/app/help/support/tickets/'
      preLoaderRoute: typeof AuthAppAppHelpSupportTicketsIndexRouteImport
      parentRoute: typeof AuthAppAppHelpSupportRoute
    }
    '/_auth/app/_app/org/$orgId/staff/$staffId': {
      id: '/_auth/app/_app/org/$orgId/staff/$staffId'
      path: '/staff/$staffId'
      fullPath: '/app/org/$orgId/staff/$staffId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/schedules/new': {
      id: '/_auth/app/_app/org/$orgId/schedules/new'
      path: '/schedules/new'
      fullPath: '/app/org/$orgId/schedules/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSchedulesNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/schedules/$scheduleId': {
      id: '/_auth/app/_app/org/$orgId/schedules/$scheduleId'
      path: '/schedules/$scheduleId'
      fullPath: '/app/org/$orgId/schedules/$scheduleId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSchedulesScheduleIdRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/enrollments/new': {
      id: '/_auth/app/_app/org/$orgId/enrollments/new'
      path: '/enrollments/new'
      fullPath: '/app/org/$orgId/enrollments/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEnrollmentsNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/enrollments/$enrollmentId': {
      id: '/_auth/app/_app/org/$orgId/enrollments/$enrollmentId'
      path: '/enrollments/$enrollmentId'
      fullPath: '/app/org/$orgId/enrollments/$enrollmentId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/customers/new': {
      id: '/_auth/app/_app/org/$orgId/customers/new'
      path: '/new'
      fullPath: '/app/org/$orgId/customers/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdCustomersNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdCustomersRoute
    }
    '/_auth/app/_app/org/$orgId/customers/$customerId': {
      id: '/_auth/app/_app/org/$orgId/customers/$customerId'
      path: '/$customerId'
      fullPath: '/app/org/$orgId/customers/$customerId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdCustomersRoute
    }
    '/_auth/app/_app/org/$orgId/billing/$invoiceId': {
      id: '/_auth/app/_app/org/$orgId/billing/$invoiceId'
      path: '/billing/$invoiceId'
      fullPath: '/app/org/$orgId/billing/$invoiceId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdBillingInvoiceIdRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/help/support/tickets/$ticketId': {
      id: '/_auth/app/_app/help/support/tickets/$ticketId'
      path: '/tickets/$ticketId'
      fullPath: '/app/help/support/tickets/$ticketId'
      preLoaderRoute: typeof AuthAppAppHelpSupportTicketsTicketIdRouteImport
      parentRoute: typeof AuthAppAppHelpSupportRoute
    }
    '/_auth/app/_app/org/$orgId/staff/$staffId/': {
      id: '/_auth/app/_app/org/$orgId/staff/$staffId/'
      path: '/'
      fullPath: '/app/org/$orgId/staff/$staffId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdRoute
    }
    '/_auth/app/_app/org/$orgId/settings/payment-methods/': {
      id: '/_auth/app/_app/org/$orgId/settings/payment-methods/'
      path: '/settings/payment-methods'
      fullPath: '/app/org/$orgId/settings/payment-methods/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsPaymentMethodsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/settings/import/': {
      id: '/_auth/app/_app/org/$orgId/settings/import/'
      path: '/settings/import'
      fullPath: '/app/org/$orgId/settings/import/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsImportIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/settings/features/': {
      id: '/_auth/app/_app/org/$orgId/settings/features/'
      path: '/settings/features'
      fullPath: '/app/org/$orgId/settings/features/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsFeaturesIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/settings/billing/': {
      id: '/_auth/app/_app/org/$orgId/settings/billing/'
      path: '/settings/billing'
      fullPath: '/app/org/$orgId/settings/billing/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsBillingIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/settings/audit-events/': {
      id: '/_auth/app/_app/org/$orgId/settings/audit-events/'
      path: '/settings/audit-events'
      fullPath: '/app/org/$orgId/settings/audit-events/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsAuditEventsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/schedules/$scheduleId/': {
      id: '/_auth/app/_app/org/$orgId/schedules/$scheduleId/'
      path: '/'
      fullPath: '/app/org/$orgId/schedules/$scheduleId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSchedulesScheduleIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdSchedulesScheduleIdRoute
    }
    '/_auth/app/_app/org/$orgId/org-management/financial-analysis/': {
      id: '/_auth/app/_app/org/$orgId/org-management/financial-analysis/'
      path: '/org-management/financial-analysis'
      fullPath: '/app/org/$orgId/org-management/financial-analysis/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdOrgManagementFinancialAnalysisIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/org-management/customer-risk-analysis/': {
      id: '/_auth/app/_app/org/$orgId/org-management/customer-risk-analysis/'
      path: '/org-management/customer-risk-analysis'
      fullPath: '/app/org/$orgId/org-management/customer-risk-analysis/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdOrgManagementCustomerRiskAnalysisIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/org-management/cost-management/': {
      id: '/_auth/app/_app/org/$orgId/org-management/cost-management/'
      path: '/org-management/cost-management'
      fullPath: '/app/org/$orgId/org-management/cost-management/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdOrgManagementCostManagementIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/events/enrollment-expiry-reminder/': {
      id: '/_auth/app/_app/org/$orgId/events/enrollment-expiry-reminder/'
      path: '/events/enrollment-expiry-reminder'
      fullPath: '/app/org/$orgId/events/enrollment-expiry-reminder/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEventsEnrollmentExpiryReminderIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/events/birthday-reminder/': {
      id: '/_auth/app/_app/org/$orgId/events/birthday-reminder/'
      path: '/events/birthday-reminder'
      fullPath: '/app/org/$orgId/events/birthday-reminder/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEventsBirthdayReminderIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/customers/$customerId/': {
      id: '/_auth/app/_app/org/$orgId/customers/$customerId/'
      path: '/'
      fullPath: '/app/org/$orgId/customers/$customerId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdRoute
    }
    '/_auth/app/_app/org/$orgId/billing/new/': {
      id: '/_auth/app/_app/org/$orgId/billing/new/'
      path: '/billing/new'
      fullPath: '/app/org/$orgId/billing/new/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdBillingNewIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/staff/$staffId/schedules': {
      id: '/_auth/app/_app/org/$orgId/staff/$staffId/schedules'
      path: '/schedules'
      fullPath: '/app/org/$orgId/staff/$staffId/schedules'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdSchedulesRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdRoute
    }
    '/_auth/app/_app/org/$orgId/staff/$staffId/permissions': {
      id: '/_auth/app/_app/org/$orgId/staff/$staffId/permissions'
      path: '/permissions'
      fullPath: '/app/org/$orgId/staff/$staffId/permissions'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdPermissionsRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdRoute
    }
    '/_auth/app/_app/org/$orgId/staff/$staffId/migrate-schedules': {
      id: '/_auth/app/_app/org/$orgId/staff/$staffId/migrate-schedules'
      path: '/migrate-schedules'
      fullPath: '/app/org/$orgId/staff/$staffId/migrate-schedules'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdMigrateSchedulesRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdRoute
    }
    '/_auth/app/_app/org/$orgId/staff/$staffId/edit': {
      id: '/_auth/app/_app/org/$orgId/staff/$staffId/edit'
      path: '/edit'
      fullPath: '/app/org/$orgId/staff/$staffId/edit'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdEditRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdRoute
    }
    '/_auth/app/_app/org/$orgId/settings/import/customers': {
      id: '/_auth/app/_app/org/$orgId/settings/import/customers'
      path: '/settings/import/customers'
      fullPath: '/app/org/$orgId/settings/import/customers'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsImportCustomersRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/schedules/$scheduleId/sessions': {
      id: '/_auth/app/_app/org/$orgId/schedules/$scheduleId/sessions'
      path: '/sessions'
      fullPath: '/app/org/$orgId/schedules/$scheduleId/sessions'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSchedulesScheduleIdSessionsRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdSchedulesScheduleIdRoute
    }
    '/_auth/app/_app/org/$orgId/schedules/$scheduleId/enrollments': {
      id: '/_auth/app/_app/org/$orgId/schedules/$scheduleId/enrollments'
      path: '/enrollments'
      fullPath: '/app/org/$orgId/schedules/$scheduleId/enrollments'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSchedulesScheduleIdEnrollmentsRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdSchedulesScheduleIdRoute
    }
    '/_auth/app/_app/org/$orgId/enrollments/$enrollmentId/edit': {
      id: '/_auth/app/_app/org/$orgId/enrollments/$enrollmentId/edit'
      path: '/edit'
      fullPath: '/app/org/$orgId/enrollments/$enrollmentId/edit'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdEditRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRoute
    }
    '/_auth/app/_app/org/$orgId/enrollments/$enrollmentId/billing': {
      id: '/_auth/app/_app/org/$orgId/enrollments/$enrollmentId/billing'
      path: '/billing'
      fullPath: '/app/org/$orgId/enrollments/$enrollmentId/billing'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdBillingRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRoute
    }
    '/_auth/app/_app/org/$orgId/customers/$customerId/sessions': {
      id: '/_auth/app/_app/org/$orgId/customers/$customerId/sessions'
      path: '/sessions'
      fullPath: '/app/org/$orgId/customers/$customerId/sessions'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdSessionsRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdRoute
    }
    '/_auth/app/_app/org/$orgId/customers/$customerId/enrollments': {
      id: '/_auth/app/_app/org/$orgId/customers/$customerId/enrollments'
      path: '/enrollments'
      fullPath: '/app/org/$orgId/customers/$customerId/enrollments'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdEnrollmentsRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdRoute
    }
    '/_auth/app/_app/org/$orgId/customers/$customerId/edit': {
      id: '/_auth/app/_app/org/$orgId/customers/$customerId/edit'
      path: '/edit'
      fullPath: '/app/org/$orgId/customers/$customerId/edit'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdEditRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdRoute
    }
    '/_auth/app/_app/org/$orgId/customers/$customerId/billing': {
      id: '/_auth/app/_app/org/$orgId/customers/$customerId/billing'
      path: '/billing'
      fullPath: '/app/org/$orgId/customers/$customerId/billing'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdBillingRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdRoute
    }
    '/_auth/app/_app/org/$orgId/billing/$invoiceId/refunds': {
      id: '/_auth/app/_app/org/$orgId/billing/$invoiceId/refunds'
      path: '/refunds'
      fullPath: '/app/org/$orgId/billing/$invoiceId/refunds'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdBillingInvoiceIdRefundsRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdBillingInvoiceIdRoute
    }
    '/_auth/app/_app/org/$orgId/billing/$invoiceId/payments': {
      id: '/_auth/app/_app/org/$orgId/billing/$invoiceId/payments'
      path: '/payments'
      fullPath: '/app/org/$orgId/billing/$invoiceId/payments'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdBillingInvoiceIdPaymentsRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdBillingInvoiceIdRoute
    }
    '/_auth/app/_app/org/$orgId/billing/$invoiceId/overview': {
      id: '/_auth/app/_app/org/$orgId/billing/$invoiceId/overview'
      path: '/overview'
      fullPath: '/app/org/$orgId/billing/$invoiceId/overview'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdBillingInvoiceIdOverviewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdBillingInvoiceIdRoute
    }
    '/_auth/app/_app/org/$orgId/billing/$invoiceId/disputes': {
      id: '/_auth/app/_app/org/$orgId/billing/$invoiceId/disputes'
      path: '/disputes'
      fullPath: '/app/org/$orgId/billing/$invoiceId/disputes'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdBillingInvoiceIdDisputesRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdBillingInvoiceIdRoute
    }
    '/_auth/app/_app/org/$orgId/attendance/session/$sessionId': {
      id: '/_auth/app/_app/org/$orgId/attendance/session/$sessionId'
      path: '/session/$sessionId'
      fullPath: '/app/org/$orgId/attendance/session/$sessionId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdAttendanceSessionSessionIdRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdAttendanceRoute
    }
    '/_auth/app/_app/org/$orgId/org-management/cost-management/recurring/': {
      id: '/_auth/app/_app/org/$orgId/org-management/cost-management/recurring/'
      path: '/org-management/cost-management/recurring'
      fullPath: '/app/org/$orgId/org-management/cost-management/recurring/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdOrgManagementCostManagementRecurringIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/org-management/cost-management/expenses/': {
      id: '/_auth/app/_app/org/$orgId/org-management/cost-management/expenses/'
      path: '/org-management/cost-management/expenses'
      fullPath: '/app/org/$orgId/org-management/cost-management/expenses/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdOrgManagementCostManagementExpensesIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/org-management/cost-management/categories/': {
      id: '/_auth/app/_app/org/$orgId/org-management/cost-management/categories/'
      path: '/org-management/cost-management/categories'
      fullPath: '/app/org/$orgId/org-management/cost-management/categories/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdOrgManagementCostManagementCategoriesIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/customers/$customerId/medicalRecords/': {
      id: '/_auth/app/_app/org/$orgId/customers/$customerId/medicalRecords/'
      path: '/medicalRecords'
      fullPath: '/app/org/$orgId/customers/$customerId/medicalRecords/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdRoute
    }
    '/_auth/app/_app/org/$orgId/customers/$customerId/medicalRecords/new': {
      id: '/_auth/app/_app/org/$orgId/customers/$customerId/medicalRecords/new'
      path: '/medicalRecords/new'
      fullPath: '/app/org/$orgId/customers/$customerId/medicalRecords/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdRoute
    }
  }
}

interface AuthAppAppHelpSupportRouteChildren {
  AuthAppAppHelpSupportIndexRoute: typeof AuthAppAppHelpSupportIndexRoute
  AuthAppAppHelpSupportTicketsTicketIdRoute: typeof AuthAppAppHelpSupportTicketsTicketIdRoute
  AuthAppAppHelpSupportTicketsIndexRoute: typeof AuthAppAppHelpSupportTicketsIndexRoute
}

const AuthAppAppHelpSupportRouteChildren: AuthAppAppHelpSupportRouteChildren = {
  AuthAppAppHelpSupportIndexRoute: AuthAppAppHelpSupportIndexRoute,
  AuthAppAppHelpSupportTicketsTicketIdRoute:
    AuthAppAppHelpSupportTicketsTicketIdRoute,
  AuthAppAppHelpSupportTicketsIndexRoute:
    AuthAppAppHelpSupportTicketsIndexRoute,
}

const AuthAppAppHelpSupportRouteWithChildren =
  AuthAppAppHelpSupportRoute._addFileChildren(
    AuthAppAppHelpSupportRouteChildren,
  )

interface AuthAppAppHelpUserGuideRouteChildren {
  AuthAppAppHelpUserGuideAttendanceTrackingRoute: typeof AuthAppAppHelpUserGuideAttendanceTrackingRoute
  AuthAppAppHelpUserGuideCustomerManagementRoute: typeof AuthAppAppHelpUserGuideCustomerManagementRoute
  AuthAppAppHelpUserGuideCustomerPlansRoute: typeof AuthAppAppHelpUserGuideCustomerPlansRoute
  AuthAppAppHelpUserGuideEnrollmentProcessRoute: typeof AuthAppAppHelpUserGuideEnrollmentProcessRoute
  AuthAppAppHelpUserGuideScheduleManagementRoute: typeof AuthAppAppHelpUserGuideScheduleManagementRoute
  AuthAppAppHelpUserGuideStaffManagementRoute: typeof AuthAppAppHelpUserGuideStaffManagementRoute
  AuthAppAppHelpUserGuideIndexRoute: typeof AuthAppAppHelpUserGuideIndexRoute
}

const AuthAppAppHelpUserGuideRouteChildren: AuthAppAppHelpUserGuideRouteChildren =
  {
    AuthAppAppHelpUserGuideAttendanceTrackingRoute:
      AuthAppAppHelpUserGuideAttendanceTrackingRoute,
    AuthAppAppHelpUserGuideCustomerManagementRoute:
      AuthAppAppHelpUserGuideCustomerManagementRoute,
    AuthAppAppHelpUserGuideCustomerPlansRoute:
      AuthAppAppHelpUserGuideCustomerPlansRoute,
    AuthAppAppHelpUserGuideEnrollmentProcessRoute:
      AuthAppAppHelpUserGuideEnrollmentProcessRoute,
    AuthAppAppHelpUserGuideScheduleManagementRoute:
      AuthAppAppHelpUserGuideScheduleManagementRoute,
    AuthAppAppHelpUserGuideStaffManagementRoute:
      AuthAppAppHelpUserGuideStaffManagementRoute,
    AuthAppAppHelpUserGuideIndexRoute: AuthAppAppHelpUserGuideIndexRoute,
  }

const AuthAppAppHelpUserGuideRouteWithChildren =
  AuthAppAppHelpUserGuideRoute._addFileChildren(
    AuthAppAppHelpUserGuideRouteChildren,
  )

interface AuthAppAppHelpRouteChildren {
  AuthAppAppHelpSupportRoute: typeof AuthAppAppHelpSupportRouteWithChildren
  AuthAppAppHelpUserGuideRoute: typeof AuthAppAppHelpUserGuideRouteWithChildren
  AuthAppAppHelpIndexRoute: typeof AuthAppAppHelpIndexRoute
}

const AuthAppAppHelpRouteChildren: AuthAppAppHelpRouteChildren = {
  AuthAppAppHelpSupportRoute: AuthAppAppHelpSupportRouteWithChildren,
  AuthAppAppHelpUserGuideRoute: AuthAppAppHelpUserGuideRouteWithChildren,
  AuthAppAppHelpIndexRoute: AuthAppAppHelpIndexRoute,
}

const AuthAppAppHelpRouteWithChildren = AuthAppAppHelpRoute._addFileChildren(
  AuthAppAppHelpRouteChildren,
)

interface AuthAppAppOrgOrgIdAttendanceRouteChildren {
  AuthAppAppOrgOrgIdAttendanceIndexRoute: typeof AuthAppAppOrgOrgIdAttendanceIndexRoute
  AuthAppAppOrgOrgIdAttendanceSessionSessionIdRoute: typeof AuthAppAppOrgOrgIdAttendanceSessionSessionIdRoute
}

const AuthAppAppOrgOrgIdAttendanceRouteChildren: AuthAppAppOrgOrgIdAttendanceRouteChildren =
  {
    AuthAppAppOrgOrgIdAttendanceIndexRoute:
      AuthAppAppOrgOrgIdAttendanceIndexRoute,
    AuthAppAppOrgOrgIdAttendanceSessionSessionIdRoute:
      AuthAppAppOrgOrgIdAttendanceSessionSessionIdRoute,
  }

const AuthAppAppOrgOrgIdAttendanceRouteWithChildren =
  AuthAppAppOrgOrgIdAttendanceRoute._addFileChildren(
    AuthAppAppOrgOrgIdAttendanceRouteChildren,
  )

interface AuthAppAppOrgOrgIdCustomersCustomerIdRouteChildren {
  AuthAppAppOrgOrgIdCustomersCustomerIdBillingRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdBillingRoute
  AuthAppAppOrgOrgIdCustomersCustomerIdEditRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdEditRoute
  AuthAppAppOrgOrgIdCustomersCustomerIdEnrollmentsRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdEnrollmentsRoute
  AuthAppAppOrgOrgIdCustomersCustomerIdSessionsRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdSessionsRoute
  AuthAppAppOrgOrgIdCustomersCustomerIdIndexRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdIndexRoute
  AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsNewRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsNewRoute
  AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsIndexRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsIndexRoute
}

const AuthAppAppOrgOrgIdCustomersCustomerIdRouteChildren: AuthAppAppOrgOrgIdCustomersCustomerIdRouteChildren =
  {
    AuthAppAppOrgOrgIdCustomersCustomerIdBillingRoute:
      AuthAppAppOrgOrgIdCustomersCustomerIdBillingRoute,
    AuthAppAppOrgOrgIdCustomersCustomerIdEditRoute:
      AuthAppAppOrgOrgIdCustomersCustomerIdEditRoute,
    AuthAppAppOrgOrgIdCustomersCustomerIdEnrollmentsRoute:
      AuthAppAppOrgOrgIdCustomersCustomerIdEnrollmentsRoute,
    AuthAppAppOrgOrgIdCustomersCustomerIdSessionsRoute:
      AuthAppAppOrgOrgIdCustomersCustomerIdSessionsRoute,
    AuthAppAppOrgOrgIdCustomersCustomerIdIndexRoute:
      AuthAppAppOrgOrgIdCustomersCustomerIdIndexRoute,
    AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsNewRoute:
      AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsNewRoute,
    AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsIndexRoute:
      AuthAppAppOrgOrgIdCustomersCustomerIdMedicalRecordsIndexRoute,
  }

const AuthAppAppOrgOrgIdCustomersCustomerIdRouteWithChildren =
  AuthAppAppOrgOrgIdCustomersCustomerIdRoute._addFileChildren(
    AuthAppAppOrgOrgIdCustomersCustomerIdRouteChildren,
  )

interface AuthAppAppOrgOrgIdCustomersRouteChildren {
  AuthAppAppOrgOrgIdCustomersCustomerIdRoute: typeof AuthAppAppOrgOrgIdCustomersCustomerIdRouteWithChildren
  AuthAppAppOrgOrgIdCustomersNewRoute: typeof AuthAppAppOrgOrgIdCustomersNewRoute
  AuthAppAppOrgOrgIdCustomersIndexRoute: typeof AuthAppAppOrgOrgIdCustomersIndexRoute
}

const AuthAppAppOrgOrgIdCustomersRouteChildren: AuthAppAppOrgOrgIdCustomersRouteChildren =
  {
    AuthAppAppOrgOrgIdCustomersCustomerIdRoute:
      AuthAppAppOrgOrgIdCustomersCustomerIdRouteWithChildren,
    AuthAppAppOrgOrgIdCustomersNewRoute: AuthAppAppOrgOrgIdCustomersNewRoute,
    AuthAppAppOrgOrgIdCustomersIndexRoute:
      AuthAppAppOrgOrgIdCustomersIndexRoute,
  }

const AuthAppAppOrgOrgIdCustomersRouteWithChildren =
  AuthAppAppOrgOrgIdCustomersRoute._addFileChildren(
    AuthAppAppOrgOrgIdCustomersRouteChildren,
  )

interface AuthAppAppOrgOrgIdBillingInvoiceIdRouteChildren {
  AuthAppAppOrgOrgIdBillingInvoiceIdDisputesRoute: typeof AuthAppAppOrgOrgIdBillingInvoiceIdDisputesRoute
  AuthAppAppOrgOrgIdBillingInvoiceIdOverviewRoute: typeof AuthAppAppOrgOrgIdBillingInvoiceIdOverviewRoute
  AuthAppAppOrgOrgIdBillingInvoiceIdPaymentsRoute: typeof AuthAppAppOrgOrgIdBillingInvoiceIdPaymentsRoute
  AuthAppAppOrgOrgIdBillingInvoiceIdRefundsRoute: typeof AuthAppAppOrgOrgIdBillingInvoiceIdRefundsRoute
}

const AuthAppAppOrgOrgIdBillingInvoiceIdRouteChildren: AuthAppAppOrgOrgIdBillingInvoiceIdRouteChildren =
  {
    AuthAppAppOrgOrgIdBillingInvoiceIdDisputesRoute:
      AuthAppAppOrgOrgIdBillingInvoiceIdDisputesRoute,
    AuthAppAppOrgOrgIdBillingInvoiceIdOverviewRoute:
      AuthAppAppOrgOrgIdBillingInvoiceIdOverviewRoute,
    AuthAppAppOrgOrgIdBillingInvoiceIdPaymentsRoute:
      AuthAppAppOrgOrgIdBillingInvoiceIdPaymentsRoute,
    AuthAppAppOrgOrgIdBillingInvoiceIdRefundsRoute:
      AuthAppAppOrgOrgIdBillingInvoiceIdRefundsRoute,
  }

const AuthAppAppOrgOrgIdBillingInvoiceIdRouteWithChildren =
  AuthAppAppOrgOrgIdBillingInvoiceIdRoute._addFileChildren(
    AuthAppAppOrgOrgIdBillingInvoiceIdRouteChildren,
  )

interface AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRouteChildren {
  AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdBillingRoute: typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdBillingRoute
  AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdEditRoute: typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdEditRoute
}

const AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRouteChildren: AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRouteChildren =
  {
    AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdBillingRoute:
      AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdBillingRoute,
    AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdEditRoute:
      AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdEditRoute,
  }

const AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRouteWithChildren =
  AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRoute._addFileChildren(
    AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRouteChildren,
  )

interface AuthAppAppOrgOrgIdSchedulesScheduleIdRouteChildren {
  AuthAppAppOrgOrgIdSchedulesScheduleIdEnrollmentsRoute: typeof AuthAppAppOrgOrgIdSchedulesScheduleIdEnrollmentsRoute
  AuthAppAppOrgOrgIdSchedulesScheduleIdSessionsRoute: typeof AuthAppAppOrgOrgIdSchedulesScheduleIdSessionsRoute
  AuthAppAppOrgOrgIdSchedulesScheduleIdIndexRoute: typeof AuthAppAppOrgOrgIdSchedulesScheduleIdIndexRoute
}

const AuthAppAppOrgOrgIdSchedulesScheduleIdRouteChildren: AuthAppAppOrgOrgIdSchedulesScheduleIdRouteChildren =
  {
    AuthAppAppOrgOrgIdSchedulesScheduleIdEnrollmentsRoute:
      AuthAppAppOrgOrgIdSchedulesScheduleIdEnrollmentsRoute,
    AuthAppAppOrgOrgIdSchedulesScheduleIdSessionsRoute:
      AuthAppAppOrgOrgIdSchedulesScheduleIdSessionsRoute,
    AuthAppAppOrgOrgIdSchedulesScheduleIdIndexRoute:
      AuthAppAppOrgOrgIdSchedulesScheduleIdIndexRoute,
  }

const AuthAppAppOrgOrgIdSchedulesScheduleIdRouteWithChildren =
  AuthAppAppOrgOrgIdSchedulesScheduleIdRoute._addFileChildren(
    AuthAppAppOrgOrgIdSchedulesScheduleIdRouteChildren,
  )

interface AuthAppAppOrgOrgIdStaffStaffIdRouteChildren {
  AuthAppAppOrgOrgIdStaffStaffIdEditRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdEditRoute
  AuthAppAppOrgOrgIdStaffStaffIdMigrateSchedulesRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdMigrateSchedulesRoute
  AuthAppAppOrgOrgIdStaffStaffIdPermissionsRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdPermissionsRoute
  AuthAppAppOrgOrgIdStaffStaffIdSchedulesRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdSchedulesRoute
  AuthAppAppOrgOrgIdStaffStaffIdIndexRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdIndexRoute
}

const AuthAppAppOrgOrgIdStaffStaffIdRouteChildren: AuthAppAppOrgOrgIdStaffStaffIdRouteChildren =
  {
    AuthAppAppOrgOrgIdStaffStaffIdEditRoute:
      AuthAppAppOrgOrgIdStaffStaffIdEditRoute,
    AuthAppAppOrgOrgIdStaffStaffIdMigrateSchedulesRoute:
      AuthAppAppOrgOrgIdStaffStaffIdMigrateSchedulesRoute,
    AuthAppAppOrgOrgIdStaffStaffIdPermissionsRoute:
      AuthAppAppOrgOrgIdStaffStaffIdPermissionsRoute,
    AuthAppAppOrgOrgIdStaffStaffIdSchedulesRoute:
      AuthAppAppOrgOrgIdStaffStaffIdSchedulesRoute,
    AuthAppAppOrgOrgIdStaffStaffIdIndexRoute:
      AuthAppAppOrgOrgIdStaffStaffIdIndexRoute,
  }

const AuthAppAppOrgOrgIdStaffStaffIdRouteWithChildren =
  AuthAppAppOrgOrgIdStaffStaffIdRoute._addFileChildren(
    AuthAppAppOrgOrgIdStaffStaffIdRouteChildren,
  )

interface AuthAppAppOrgOrgIdRouteChildren {
  AuthAppAppOrgOrgIdAttendanceRoute: typeof AuthAppAppOrgOrgIdAttendanceRouteWithChildren
  AuthAppAppOrgOrgIdCustomersRoute: typeof AuthAppAppOrgOrgIdCustomersRouteWithChildren
  AuthAppAppOrgOrgIdUnder_developmentRoute: typeof AuthAppAppOrgOrgIdUnder_developmentRoute
  AuthAppAppOrgOrgIdIndexRoute: typeof AuthAppAppOrgOrgIdIndexRoute
  AuthAppAppOrgOrgIdBillingInvoiceIdRoute: typeof AuthAppAppOrgOrgIdBillingInvoiceIdRouteWithChildren
  AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRoute: typeof AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRouteWithChildren
  AuthAppAppOrgOrgIdEnrollmentsNewRoute: typeof AuthAppAppOrgOrgIdEnrollmentsNewRoute
  AuthAppAppOrgOrgIdSchedulesScheduleIdRoute: typeof AuthAppAppOrgOrgIdSchedulesScheduleIdRouteWithChildren
  AuthAppAppOrgOrgIdSchedulesNewRoute: typeof AuthAppAppOrgOrgIdSchedulesNewRoute
  AuthAppAppOrgOrgIdStaffStaffIdRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdRouteWithChildren
  AuthAppAppOrgOrgIdBillingIndexRoute: typeof AuthAppAppOrgOrgIdBillingIndexRoute
  AuthAppAppOrgOrgIdCustomerPlansIndexRoute: typeof AuthAppAppOrgOrgIdCustomerPlansIndexRoute
  AuthAppAppOrgOrgIdEnrollmentsIndexRoute: typeof AuthAppAppOrgOrgIdEnrollmentsIndexRoute
  AuthAppAppOrgOrgIdEstablishmentsIndexRoute: typeof AuthAppAppOrgOrgIdEstablishmentsIndexRoute
  AuthAppAppOrgOrgIdOrgManagementIndexRoute: typeof AuthAppAppOrgOrgIdOrgManagementIndexRoute
  AuthAppAppOrgOrgIdSchedulesIndexRoute: typeof AuthAppAppOrgOrgIdSchedulesIndexRoute
  AuthAppAppOrgOrgIdSettingsIndexRoute: typeof AuthAppAppOrgOrgIdSettingsIndexRoute
  AuthAppAppOrgOrgIdStaffIndexRoute: typeof AuthAppAppOrgOrgIdStaffIndexRoute
  AuthAppAppOrgOrgIdSettingsImportCustomersRoute: typeof AuthAppAppOrgOrgIdSettingsImportCustomersRoute
  AuthAppAppOrgOrgIdBillingNewIndexRoute: typeof AuthAppAppOrgOrgIdBillingNewIndexRoute
  AuthAppAppOrgOrgIdEventsBirthdayReminderIndexRoute: typeof AuthAppAppOrgOrgIdEventsBirthdayReminderIndexRoute
  AuthAppAppOrgOrgIdEventsEnrollmentExpiryReminderIndexRoute: typeof AuthAppAppOrgOrgIdEventsEnrollmentExpiryReminderIndexRoute
  AuthAppAppOrgOrgIdOrgManagementCostManagementIndexRoute: typeof AuthAppAppOrgOrgIdOrgManagementCostManagementIndexRoute
  AuthAppAppOrgOrgIdOrgManagementCustomerRiskAnalysisIndexRoute: typeof AuthAppAppOrgOrgIdOrgManagementCustomerRiskAnalysisIndexRoute
  AuthAppAppOrgOrgIdOrgManagementFinancialAnalysisIndexRoute: typeof AuthAppAppOrgOrgIdOrgManagementFinancialAnalysisIndexRoute
  AuthAppAppOrgOrgIdSettingsAuditEventsIndexRoute: typeof AuthAppAppOrgOrgIdSettingsAuditEventsIndexRoute
  AuthAppAppOrgOrgIdSettingsBillingIndexRoute: typeof AuthAppAppOrgOrgIdSettingsBillingIndexRoute
  AuthAppAppOrgOrgIdSettingsFeaturesIndexRoute: typeof AuthAppAppOrgOrgIdSettingsFeaturesIndexRoute
  AuthAppAppOrgOrgIdSettingsImportIndexRoute: typeof AuthAppAppOrgOrgIdSettingsImportIndexRoute
  AuthAppAppOrgOrgIdSettingsPaymentMethodsIndexRoute: typeof AuthAppAppOrgOrgIdSettingsPaymentMethodsIndexRoute
  AuthAppAppOrgOrgIdOrgManagementCostManagementCategoriesIndexRoute: typeof AuthAppAppOrgOrgIdOrgManagementCostManagementCategoriesIndexRoute
  AuthAppAppOrgOrgIdOrgManagementCostManagementExpensesIndexRoute: typeof AuthAppAppOrgOrgIdOrgManagementCostManagementExpensesIndexRoute
  AuthAppAppOrgOrgIdOrgManagementCostManagementRecurringIndexRoute: typeof AuthAppAppOrgOrgIdOrgManagementCostManagementRecurringIndexRoute
}

const AuthAppAppOrgOrgIdRouteChildren: AuthAppAppOrgOrgIdRouteChildren = {
  AuthAppAppOrgOrgIdAttendanceRoute:
    AuthAppAppOrgOrgIdAttendanceRouteWithChildren,
  AuthAppAppOrgOrgIdCustomersRoute:
    AuthAppAppOrgOrgIdCustomersRouteWithChildren,
  AuthAppAppOrgOrgIdUnder_developmentRoute:
    AuthAppAppOrgOrgIdUnder_developmentRoute,
  AuthAppAppOrgOrgIdIndexRoute: AuthAppAppOrgOrgIdIndexRoute,
  AuthAppAppOrgOrgIdBillingInvoiceIdRoute:
    AuthAppAppOrgOrgIdBillingInvoiceIdRouteWithChildren,
  AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRoute:
    AuthAppAppOrgOrgIdEnrollmentsEnrollmentIdRouteWithChildren,
  AuthAppAppOrgOrgIdEnrollmentsNewRoute: AuthAppAppOrgOrgIdEnrollmentsNewRoute,
  AuthAppAppOrgOrgIdSchedulesScheduleIdRoute:
    AuthAppAppOrgOrgIdSchedulesScheduleIdRouteWithChildren,
  AuthAppAppOrgOrgIdSchedulesNewRoute: AuthAppAppOrgOrgIdSchedulesNewRoute,
  AuthAppAppOrgOrgIdStaffStaffIdRoute:
    AuthAppAppOrgOrgIdStaffStaffIdRouteWithChildren,
  AuthAppAppOrgOrgIdBillingIndexRoute: AuthAppAppOrgOrgIdBillingIndexRoute,
  AuthAppAppOrgOrgIdCustomerPlansIndexRoute:
    AuthAppAppOrgOrgIdCustomerPlansIndexRoute,
  AuthAppAppOrgOrgIdEnrollmentsIndexRoute:
    AuthAppAppOrgOrgIdEnrollmentsIndexRoute,
  AuthAppAppOrgOrgIdEstablishmentsIndexRoute:
    AuthAppAppOrgOrgIdEstablishmentsIndexRoute,
  AuthAppAppOrgOrgIdOrgManagementIndexRoute:
    AuthAppAppOrgOrgIdOrgManagementIndexRoute,
  AuthAppAppOrgOrgIdSchedulesIndexRoute: AuthAppAppOrgOrgIdSchedulesIndexRoute,
  AuthAppAppOrgOrgIdSettingsIndexRoute: AuthAppAppOrgOrgIdSettingsIndexRoute,
  AuthAppAppOrgOrgIdStaffIndexRoute: AuthAppAppOrgOrgIdStaffIndexRoute,
  AuthAppAppOrgOrgIdSettingsImportCustomersRoute:
    AuthAppAppOrgOrgIdSettingsImportCustomersRoute,
  AuthAppAppOrgOrgIdBillingNewIndexRoute:
    AuthAppAppOrgOrgIdBillingNewIndexRoute,
  AuthAppAppOrgOrgIdEventsBirthdayReminderIndexRoute:
    AuthAppAppOrgOrgIdEventsBirthdayReminderIndexRoute,
  AuthAppAppOrgOrgIdEventsEnrollmentExpiryReminderIndexRoute:
    AuthAppAppOrgOrgIdEventsEnrollmentExpiryReminderIndexRoute,
  AuthAppAppOrgOrgIdOrgManagementCostManagementIndexRoute:
    AuthAppAppOrgOrgIdOrgManagementCostManagementIndexRoute,
  AuthAppAppOrgOrgIdOrgManagementCustomerRiskAnalysisIndexRoute:
    AuthAppAppOrgOrgIdOrgManagementCustomerRiskAnalysisIndexRoute,
  AuthAppAppOrgOrgIdOrgManagementFinancialAnalysisIndexRoute:
    AuthAppAppOrgOrgIdOrgManagementFinancialAnalysisIndexRoute,
  AuthAppAppOrgOrgIdSettingsAuditEventsIndexRoute:
    AuthAppAppOrgOrgIdSettingsAuditEventsIndexRoute,
  AuthAppAppOrgOrgIdSettingsBillingIndexRoute:
    AuthAppAppOrgOrgIdSettingsBillingIndexRoute,
  AuthAppAppOrgOrgIdSettingsFeaturesIndexRoute:
    AuthAppAppOrgOrgIdSettingsFeaturesIndexRoute,
  AuthAppAppOrgOrgIdSettingsImportIndexRoute:
    AuthAppAppOrgOrgIdSettingsImportIndexRoute,
  AuthAppAppOrgOrgIdSettingsPaymentMethodsIndexRoute:
    AuthAppAppOrgOrgIdSettingsPaymentMethodsIndexRoute,
  AuthAppAppOrgOrgIdOrgManagementCostManagementCategoriesIndexRoute:
    AuthAppAppOrgOrgIdOrgManagementCostManagementCategoriesIndexRoute,
  AuthAppAppOrgOrgIdOrgManagementCostManagementExpensesIndexRoute:
    AuthAppAppOrgOrgIdOrgManagementCostManagementExpensesIndexRoute,
  AuthAppAppOrgOrgIdOrgManagementCostManagementRecurringIndexRoute:
    AuthAppAppOrgOrgIdOrgManagementCostManagementRecurringIndexRoute,
}

const AuthAppAppOrgOrgIdRouteWithChildren =
  AuthAppAppOrgOrgIdRoute._addFileChildren(AuthAppAppOrgOrgIdRouteChildren)

interface AuthAppAppRouteChildren {
  AuthAppAppHelpRoute: typeof AuthAppAppHelpRouteWithChildren
  AuthAppAppIndexRoute: typeof AuthAppAppIndexRoute
  AuthAppAppOrgOrgIdRoute: typeof AuthAppAppOrgOrgIdRouteWithChildren
  AuthAppAppOrgRenewSubscriptionRoute: typeof AuthAppAppOrgRenewSubscriptionRoute
  AuthAppAppUserSettingsIndexRoute: typeof AuthAppAppUserSettingsIndexRoute
}

const AuthAppAppRouteChildren: AuthAppAppRouteChildren = {
  AuthAppAppHelpRoute: AuthAppAppHelpRouteWithChildren,
  AuthAppAppIndexRoute: AuthAppAppIndexRoute,
  AuthAppAppOrgOrgIdRoute: AuthAppAppOrgOrgIdRouteWithChildren,
  AuthAppAppOrgRenewSubscriptionRoute: AuthAppAppOrgRenewSubscriptionRoute,
  AuthAppAppUserSettingsIndexRoute: AuthAppAppUserSettingsIndexRoute,
}

const AuthAppAppRouteWithChildren = AuthAppAppRoute._addFileChildren(
  AuthAppAppRouteChildren,
)

interface AuthRouteChildren {
  AuthAppAppRoute: typeof AuthAppAppRouteWithChildren
  AuthAppSelectOrganizationRoute: typeof AuthAppSelectOrganizationRoute
  AuthStaffInviteTokenRoute: typeof AuthStaffInviteTokenRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAppAppRoute: AuthAppAppRouteWithChildren,
  AuthAppSelectOrganizationRoute: AuthAppSelectOrganizationRoute,
  AuthStaffInviteTokenRoute: AuthStaffInviteTokenRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicRouteChildren {
  PublicAboutRoute: typeof PublicAboutRoute
  PublicPricingRoute: typeof PublicPricingRoute
  PublicPrivacyPolicyRoute: typeof PublicPrivacyPolicyRoute
  PublicIndexRoute: typeof PublicIndexRoute
  PublicSignInSplatRoute: typeof PublicSignInSplatRoute
  PublicSignUpSplatRoute: typeof PublicSignUpSplatRoute
  PublicSignInIndexRoute: typeof PublicSignInIndexRoute
  PublicSignUpIndexRoute: typeof PublicSignUpIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicAboutRoute: PublicAboutRoute,
  PublicPricingRoute: PublicPricingRoute,
  PublicPrivacyPolicyRoute: PublicPrivacyPolicyRoute,
  PublicIndexRoute: PublicIndexRoute,
  PublicSignInSplatRoute: PublicSignInSplatRoute,
  PublicSignUpSplatRoute: PublicSignUpSplatRoute,
  PublicSignInIndexRoute: PublicSignInIndexRoute,
  PublicSignUpIndexRoute: PublicSignUpIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
